<template>
  <v-container
    fluid
    class="d-flex justify-center align-center"
    pa-md-4
    pa-2
    style="min-height: 10vh; border-radius: 0"
  >
    <v-row class="d-flex justify-center">
      <v-col cols="12" sm="6" md="4" lg="10">
        <v-card rounded="0">
          <v-toolbar flat dense color="#005F95">
            <div>
              <!-- Small to Large Screens -->
              <h1
                class="NewApp-Toolbar"
                :style="{
                  fontSize: isSmall ? '11px' : isMedium ? '16px' : '20px',
                }"
              >
                DINERS CLUB {{ product }} ONLINE APPLICATION
              </h1>
            </div>
          </v-toolbar>

          <v-stepper
            v-model="step"
            style="background-color: transparent"
            vertical
          >
            <v-stepper-header style="border-radius: 0; border: 1px">
              <v-stepper-item
                title="BANKING DETAILS"
                :value="1"
                style="font-size: 4px; padding: 2px"
              />

              <v-stepper-item
                title="ADDRESS INFORMATION"
                :value="2"
                style="font-size: 4px; padding: 2px"
              />

              <v-stepper-item
                title="EMPLOYMENT INFORMATION"
                :value="3"
                style="font-size: 4px; padding: 2px"
              />

              <v-stepper-item
                title="CONSENTS & ACCEPTANCE"
                :value="4"
                style="font-size: 4px; padding: 2px"
              />

              <v-stepper-item
                title="DOCUMENTATION"
                :value="5"
                style="font-size: 4px; padding: 2px"
              />

              <v-stepper-item
                title="PDF VIEW"
                :value="6"
                style="font-size: 4px; padding: 2px"
              />
            </v-stepper-header>

            <v-stepper-window v-model="step">
              <v-stepper-window-item :value="1">
                <v-form
                  ref="bankingDetailsForm"
                  v-model="validBanking"
                  lazy-validation
                >
                  <v-container
                    fluid
                    style="
                      border: 0px solid #ccc;
                      border-radius: 0;
                      padding: 16px;
                    "
                  >
                    <v-container fluid style="border-radius: 0; padding: 16px">
                      <v-row>
                        <v-col cols="12" sm="12">
                          <h1 style="text-align: left" class="Main-Header">
                            BANKING DETAILS
                          </h1>
                        </v-col> </v-row
                      ><br />
                      <v-row>
                        <v-col sm="12">
                          <h1
                            style="text-align: left"
                            class="Your-BankingDetails"
                          >
                            YOUR BANKING DETAILS
                          </h1>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12">
                          <p
                            style="text-align: left"
                            class="paragraph-wordings"
                          >
                            Do you authorise Diners Club South Africa Pty Ltd to
                            debit your bank account monthly with the amount
                            outstanding?
                          </p>
                          <br />

                          <!-- **************************************************************************************************** -->
                          <v-row justify="center">
                            <v-radio-group
                              v-model="radiodebitorder"
                              color="#005F95"
                              inline
                              hide-details
                              :rules="[
                                (v) =>
                                  !!v || 'At least one field must be selected!',
                              ]"
                              row
                              required
                            >
                              <v-radio
                                label="Yes"
                                value="Y"
                                color="#005F95"
                              ></v-radio>

                              <v-radio
                                label="No"
                                value="N"
                                color="#005F95"
                              ></v-radio>
                            </v-radio-group>
                          </v-row>

                          <!-- Debit Order Dialog -->
                          <v-dialog
                            v-model="debitorder_dialog"
                            persistent
                            max-width="700"
                          >
                            <v-card :style="{ borderRadius: '0px' }">
                              <v-toolbar color="#005F95">
                                <v-toolbar-title row wrap class="text-center"
                                  ><p class="Dialog-Wording">
                                    DEBIT ORDER MANDATE
                                  </p></v-toolbar-title
                                >
                              </v-toolbar>

                              <v-container hide-details>
                                <v-card-text class="paragraph-wordings">
                                  By clicking <b>"Agree"</b> you accept the
                                  following terms that apply to this Debit Order
                                  Mandate: <br /><br />
                                  • If the Collection Date falls on a
                                  non-processing day (Sunday or public holiday),
                                  the Collection Amount may be debited from my
                                  Bank Account on the first working day after
                                  that. If there is not enough money in my Bank
                                  Account on the Collection Date, the Collector
                                  can track my Bank Account (at no cost to me)
                                  and debit the Collection Amount on another day
                                  when there is money in my Bank Account.
                                  <br /><br />
                                  • If I have chosen my salary date as the
                                  Collection Date and the Collector has learnt
                                  that my salary date has changed, the Collector
                                  can change the Collection Date to my new
                                  salary date.
                                  <br /><br />
                                  • The Collection Amount may change depending
                                  on what is set out in the Agreement, including
                                  if it is usage-based, there are annual
                                  increases or the interest rate changes.
                                  <br /><br />
                                  • If the Collector cannot debit the Collection
                                  Amount from my Bank Account, it will be a
                                  default under the Agreement, meaning that I
                                  have breached the Agreement. The total amount
                                  that the Collector debits from me under this
                                  Debit Order Mandate will never be more than
                                  the amounts that are due under the Agreement.
                                  <br /><br />
                                  • The Collection Amount will continue to be
                                  debited from my Bank Account under this Debit
                                  Order Mandate until I have paid all the
                                  amounts due under the Agreement or until I
                                  cancel this Debit Order Mandate by giving the
                                  Collector notice in writing of at least 30
                                  days. If I cancel the Debit Order Mandate, it
                                  will not mean that I also cancel the
                                  Agreement.
                                  <br /><br />
                                  • I will pay for any bank charges related to
                                  this Debit Order Mandate, including where the
                                  Collector cannot debit the Collection Amount.
                                  <br /><br />
                                  • This Debit Order Mandate may be ceded or
                                  assigned to a third party if the Agreement is
                                  also ceded or assigned to such third party.
                                </v-card-text>

                                <v-row>
                                  <v-col style="text-align: left">
                                    <v-btn
                                      class="white--text"
                                      color="#005F95"
                                      style="
                                        border-radius: 0;
                                        width: 150px;
                                        height: 30px;
                                      "
                                      @click="
                                        debitorder_dialog = false;
                                        manualpayment_dialog = true;
                                      "
                                    >
                                      Back
                                    </v-btn></v-col
                                  >

                                  <v-col style="text-align: right">
                                    <v-btn
                                      class="white--text"
                                      color="#005F95"
                                      style="
                                        border-radius: 0;
                                        width: 150px;
                                        height: 30px;
                                      "
                                      @click="debitorder_dialog = false"
                                    >
                                      Agree
                                    </v-btn></v-col
                                  ></v-row
                                >
                              </v-container>
                            </v-card>
                          </v-dialog>

                          <!-- Manual Payment Dialog -->
                          <v-dialog
                            v-model="manualpayment_dialog"
                            persistent
                            max-width="500"
                          >
                            <v-card :style="{ borderRadius: '0px' }">
                              <v-toolbar color="#005F95">
                                <v-toolbar-title row wrap class="text-center"
                                  ><p class="Dialog-Wording">
                                    MANUAL PAYMENT
                                  </p></v-toolbar-title
                                >
                              </v-toolbar>

                              <v-container hide-details>
                                <v-card-text class="paragraph-wordings">
                                  Please remember to make payment on the agreed
                                  date to the following account details:
                                  <br />
                                  Account holder: Diners Club SA
                                  <br />
                                  Account number: <b>001 299 123</b>
                                  <br />
                                  Reference number:
                                  <b>14 digit card number</b> to be used as
                                  reference <b>only</b>
                                </v-card-text>

                                <v-row>
                                  <v-col style="text-align: center">
                                    <v-btn
                                      class="white--text"
                                      color="#005F95"
                                      style="
                                        border-radius: 0;
                                        width: 150px;
                                        height: 30px;
                                      "
                                      @click="manualpayment_dialog = false"
                                    >
                                      OK
                                    </v-btn></v-col
                                  ></v-row
                                >
                              </v-container>
                            </v-card>
                          </v-dialog>

                          <!-- Shariah Compliance Dialog -->
                          <v-dialog
                            v-model="shariah_dialog"
                            persistent
                            max-width="600"
                          >
                            <v-card :style="{ borderRadius: '0px' }">
                              <v-toolbar color="#005F95">
                                <v-toolbar-title row wrap class="text-center"
                                  ><p class="Dialog-Wording">
                                    PLEASE NOTE
                                  </p></v-toolbar-title
                                >
                              </v-toolbar>

                              <v-container hide-details>
                                <v-card-text class="paragraph-wordings">
                                  <b
                                    >Given that this is a Shari'ah compliant
                                    product, the <u>full amount</u> due will be
                                    deducted.</b
                                  >
                                </v-card-text>

                                <v-row>
                                  <v-col style="text-align: center">
                                    <v-btn
                                      class="white--text"
                                      color="#005F95"
                                      style="
                                        border-radius: 0;
                                        width: 150px;
                                        height: 30px;
                                      "
                                      @click="shariah_dialog = false"
                                    >
                                      OK
                                    </v-btn></v-col
                                  ></v-row
                                >
                              </v-container>
                            </v-card>
                          </v-dialog>
                        </v-col> </v-row
                      ><br />

                      <!-- **************************************************************************************************** -->

                      <v-row v-if="radiodebitorder === 'Y'" class="my-4">
                        <v-col cols="12" sm="3">
                          <v-select
                            v-model="dropdownbank"
                            :items="dropdown_bank"
                            :rules="[
                              (v) => !!v || 'Name of primary bank is required',
                            ]"
                            label="Name of primary bank"
                            required
                            color="#005F95"
                            placeholder=""
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-bank"
                            @update:modelValue="branchCodes"
                          ></v-select>
                        </v-col>

                        <v-col cols="1"></v-col>

                        <v-col cols="12" sm="3">
                          <v-text-field
                            v-model="txtBranchcode"
                            label="Branch Code"
                            :rules="[
                              validateField(
                                numericFieldRegex,
                                'Invalid Branch Code'
                              ),
                            ]"
                            mask="######"
                            required
                            clearable
                            color="#005F95"
                            placeholder=""
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-map-marker"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="1"></v-col>

                        <v-col cols="12" sm="3">
                          <v-text-field
                            v-model="txtAccount"
                            label="Account Number"
                            :rules="[
                              validateField(
                                numericFieldRegex,
                                'Invalid Account Number'
                              ),
                            ]"
                            mask="####################"
                            required
                            clearable
                            color="#005F95"
                            placeholder=""
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-credit-card"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row v-if="radiodebitorder === 'Y'" class="my-4">
                        <v-col cols="12" sm="3">
                          <v-select
                            v-model="dropdownacctype"
                            :items="dropdown_acctype"
                            :rules="[(v) => !!v || 'Account Type is required']"
                            label="Account Type"
                            required
                            clearable
                            color="#005F95"
                            placeholder=""
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-account"
                          ></v-select>
                        </v-col>

                        <v-col cols="1"></v-col>

                        <v-col cols="12" sm="3">
                          <v-select
                            v-model="dropdowndebitday"
                            :items="dropdown_debitday"
                            :rules="[(v) => !!v || 'Salary Date is required']"
                            label="Salary Date"
                            required
                            clearable
                            color="#005F95"
                            placeholder=""
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-calendar"
                          ></v-select>

                          <p
                            style="text-align: left"
                            class="paragraph-wordings"
                          >
                            <v-icon
                              class="custom-help-icon"
                              color="#005F95"
                              style="cursor: pointer"
                              >mdi-help-circle-outline</v-icon
                            >
                            Please ensure that there are funds in this account
                            as your debit order will be processed on this
                            date/day
                          </p>
                        </v-col>
                      </v-row>

                      <!-- /////////////////////////////////////////----Previous and Continue Buttons----////////////////////////////////////////// -->

                      <v-row>
                        <v-col cols="6" style="text-align: left">
                          <v-btn
                            color="#005F95"
                            class="white--text"
                            @click="step = 1"
                            style="border-radius: 0; width: 170px; height: 30px"
                            >Previous</v-btn
                          >
                        </v-col>

                        <v-col cols="6" style="text-align: right">
                          <v-btn
                            color="#005F95"
                            class="white--text"
                            @click="updateBankingDetails()"
                            style="border-radius: 0; width: 170px; height: 30px"
                            :loading="isLoading"
                            :disabled="!isBankingDetailsFormValid"
                          >
                            <span v-if="!isLoading">CONTINUE</span>
                          </v-btn>
                        </v-col>
                      </v-row>
                      <!-- /////////////////////////////////////////////////////////////////////////////////// -->
                    </v-container>
                  </v-container>
                </v-form>
              </v-stepper-window-item>

              <!-- ####################################################################--STEPPER 2 : ADDRESS INFORMATION---########################################################################### -->

              <v-stepper-window-item :value="2">
                <v-form
                  ref="addressInfoForm"
                  v-model="validAddress"
                  lazy-validation
                >
                  <v-container
                    fluid
                    style="
                      border: 0px solid #ccc;
                      border-radius: 0;
                      padding: 16px;
                    "
                  >
                    <v-container fluid style="border-radius: 0; padding: 16px">
                      <v-row>
                        <v-col cols="12" sm="12">
                          <p style="text-align: left" class="Main-Header">
                            RESIDENTIAL ADDRESS INFORMATION
                          </p>
                        </v-col>
                      </v-row>
                      <br />

                      <!-- *******************************---Residential Address----************************************* -->

                      <v-row>
                        <v-col cols="12" sm="3">
                          <v-text-field
                            v-model="txtAddress1"
                            label="Address Line 1"
                            :rules="[
                              validateField(
                                alphaNumericFieldRegex,
                                'Invalid Address Line 1'
                              ),
                            ]"
                            @keyup="uppercase"
                            maxlength="30"
                            counter
                            required
                            placeholder
                            color="#005F95"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-map-marker"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="1"></v-col>

                        <v-col cols="12" sm="3">
                          <v-text-field
                            v-model="txtAddress2"
                            label="Address Line 2"
                            :rules="[
                              validateField(
                                alphaNumericFieldRegex,
                                'Invalid Address Line 2'
                              ),
                            ]"
                            @keyup="uppercase"
                            maxlength="30"
                            counter
                            required
                            placeholder
                            color="#005F95"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-map-marker"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="1"></v-col>

                        <v-col cols="12" sm="3">
                          <v-text-field
                            v-model="txtSuburb"
                            label="Suburb"
                            :rules="[
                              validateField(
                                textFieldRegex,
                                'Please enter text only'
                              ),
                            ]"
                            @keyup="uppercase"
                            maxlength="50"
                            counter
                            required
                            placeholder
                            color="#005F95"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-city"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <!-- ******************************************************************** -->

                      <v-row>
                        <v-col cols="12" sm="3">
                          <v-text-field
                            v-model="txtCity"
                            label="City / Town"
                            :rules="[
                              validateField(
                                textFieldRegex,
                                'Please enter text only'
                              ),
                            ]"
                            @keyup="uppercase"
                            maxlength="50"
                            counter
                            required
                            autocomplete="txtCity"
                            placeholder
                            color="#005F95"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-city"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="1"></v-col>

                        <v-col cols="12" sm="3">
                          <v-select
                            v-model="dropdownProvince"
                            :items="dropdown_province"
                            color="#005F95"
                            label="Province"
                            :rules="[(v) => !!v || 'Province is required']"
                            required
                            clearable
                            placeholder=""
                            type="text"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-map"
                          ></v-select>
                        </v-col>

                        <v-col cols="1"></v-col>

                        <v-col cols="12" sm="3">
                          <v-text-field
                            v-model="txtCode"
                            :rules="[
                              validateField(
                                numericFieldRegex,
                                'Please enter numbers only'
                              ),
                            ]"
                            mask="####"
                            label="Postal Code"
                            maxlength="4"
                            counter
                            required
                            placeholder
                            color="#005F95"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-home"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <!-- ******************************************************************** -->

                      <v-row>
                        <v-col cols="12" sm="3">
                          <v-select
                            v-model="dropdownCountryOfResidentialAddress"
                            :items="dropdown_CountryOfResidentialAddress"
                            label="Country Of Residential Address"
                            :rules="[
                              (v) =>
                                !!v ||
                                'Country of Residential Address is required',
                            ]"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-city"
                            required
                            clearable
                            placeholder=""
                            type="text"
                            color="#005F95"
                          ></v-select>
                        </v-col>

                        <v-col cols="1"></v-col>

                        <v-col cols="12" sm="4">
                          <v-checkbox
                            v-model="check_PostalAddress"
                            value="Y"
                            color="#005F95"
                            v-on:change="ClearAddressDetails()"
                          >
                            <template #label>
                              <span id="checkboxLabel"
                                >Postal address same as residential address
                                ?</span
                              >
                            </template>
                          </v-checkbox>
                        </v-col>
                      </v-row>

                      <!-- ***********************************----End Of Residential Adress----********************************* -->

                      <v-row v-if="check_PostalAddress !== 'Y'">
                        <v-col cols="12" sm="12">
                          <p style="text-align: left" class="Main-Header">
                            POSTAL ADDRESS INFORMATION
                          </p>
                        </v-col>
                      </v-row>

                      <!-- *******************************---Postal Address----************************************* -->

                      <v-row v-if="check_PostalAddress !== 'Y'">
                        <v-col cols="12" sm="3">
                          <v-text-field
                            v-model="txtPAddress1"
                            label="Address Line 1"
                            :rules="[
                              validateField(
                                alphaNumericFieldRegex,
                                'Invalid Address Line 1'
                              ),
                            ]"
                            @keyup="uppercase"
                            maxlength="30"
                            counter
                            required
                            placeholder
                            color="#005F95"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-map-marker"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="1"></v-col>

                        <v-col cols="12" sm="3">
                          <v-text-field
                            v-model="txtPAddress2"
                            label="Address Line 2"
                            :rules="[
                              validateField(
                                alphaNumericFieldRegex,
                                'Invalid Address Line 2'
                              ),
                            ]"
                            @keyup="uppercase"
                            maxlength="30"
                            counter
                            required
                            placeholder
                            color="#005F95"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-map-marker"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="1"></v-col>

                        <v-col cols="12" sm="3">
                          <v-text-field
                            v-model="txtPSuburb"
                            label="Suburb"
                            :rules="[
                              validateField(
                                textFieldRegex,
                                'Please enter text only'
                              ),
                            ]"
                            @keyup="uppercase"
                            maxlength="50"
                            counter
                            required
                            placeholder
                            color="#005F95"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-city"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <!-- ******************************************************************** -->

                      <v-row v-if="check_PostalAddress !== 'Y'">
                        <v-col cols="12" sm="3">
                          <v-text-field
                            v-model="txtPCity"
                            label="City / Town"
                            :rules="[
                              validateField(
                                textFieldRegex,
                                'Please enter text only'
                              ),
                            ]"
                            @keyup="uppercase"
                            maxlength="50"
                            counter
                            required
                            autocomplete="txtCity"
                            placeholder
                            color="#005F95"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-city"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="1"></v-col>

                        <v-col cols="12" sm="3">
                          <v-select
                            v-model="dropdownPProvince"
                            :items="dropdown_province"
                            color="#005F95"
                            label="Province"
                            :rules="[(v) => !!v || 'Province is required']"
                            required
                            clearable
                            placeholder=""
                            type="text"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-map"
                          ></v-select>
                        </v-col>

                        <v-col cols="1"></v-col>

                        <v-col cols="12" sm="3">
                          <v-text-field
                            v-model="txtPCode"
                            :rules="[
                              validateField(
                                numericFieldRegex,
                                'Please enter numbers only'
                              ),
                            ]"
                            mask="####"
                            label="Postal Code"
                            maxlength="4"
                            counter
                            required
                            placeholder
                            color="#005F95"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-home"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <!-- ******************************************************************** -->

                      <v-row v-if="check_PostalAddress !== 'Y'">
                        <v-col cols="12" sm="3">
                          <v-select
                            v-model="dropdownCountryOfPostalAddress"
                            :items="dropdown_CountryOfPostalAddress"
                            label="Country Of Postal Address"
                            :rules="[
                              (v) =>
                                !!v || 'Country of Postal Address is required',
                            ]"
                            required
                            clearable
                            color="#005F95"
                            placeholder=""
                            type="text"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-earth"
                          ></v-select>
                        </v-col>
                      </v-row>

                      <!-- ***********************************----End Of Postal Adress----********************************* -->

                      <v-row>
                        <v-col cols="6" style="text-align: left">
                          <v-btn
                            color="#005F95"
                            class="white--text"
                            @click="step = 1"
                            style="border-radius: 0; width: 170px; height: 30px"
                            >Previous</v-btn
                          >
                        </v-col>

                        <v-col cols="6" style="text-align: right">
                          <v-btn
                            color="#005F95"
                            class="white--text"
                            @click="updateResandPostAddressInfor()"
                            style="border-radius: 0; width: 170px; height: 30px"
                            :loading="isLoading"
                            :disabled="!isResandPostDetailsFormValid"
                          >
                            <span v-if="!isLoading">CONTINUE</span>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-container>
                </v-form>
              </v-stepper-window-item>

              <!-- ####################################################################--STEPPER 3 : EMPLOYMENT INFORMATION---########################################################################### -->
              <v-stepper-window-item :value="3">
                <v-form v-model="validEmployment" lazy-validation>
                  <v-container
                    fluid
                    style="
                      border: 0px solid #ccc;
                      border-radius: 0;
                      padding: 16px;
                    "
                  >
                    <v-container fluid style="border-radius: 0; padding: 16px">
                      <v-row>
                        <v-col cols="12" sm="12">
                          <h1 style="text-align: left" class="Main-Header">
                            EMPLOYMENT INFORMATION
                          </h1>
                        </v-col> </v-row
                      ><br />

                      <v-row class="align-center">
                        <v-col cols="12" sm="3">
                          <v-radio-group
                            v-model="radioemployment"
                            inline
                            :rules="[
                              (v) => !!v || 'Employment Status is required!',
                            ]"
                            required
                            row
                          >
                            <div class="d-flex align-center">
                              <span>Employed:</span>
                              <v-radio
                                label="Yes"
                                value="Y"
                                color="#005F95"
                              ></v-radio>
                              <v-radio
                                label="No"
                                value="N"
                                color="#005F95"
                              ></v-radio>
                            </div>
                          </v-radio-group>
                        </v-col>
                      </v-row>

                      <v-row
                        v-if="radioemployment === 'Y'"
                        class="d-flex align-center"
                        wrap
                      >
                        <v-col cols="12" sm="3">
                          <v-text-field
                            v-model="txtEmployer"
                            label="Current Employer Name"
                            :rules="[
                              validateField(
                                alphaNumericFieldRegex,
                                'Please enter text only'
                              ),
                            ]"
                            @keyup="uppercase"
                            maxlength="50"
                            counter
                            required
                            color="#005F95"
                            clearable
                            placeholder
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-office-building"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="1"></v-col>

                        <!--&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&----TEST---&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&-->

                        <v-col cols="12" sm="3">
                          <v-menu
                            v-model="menuEmploymentDate"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                            color="#005F95"
                          >
                            <template v-slot:activator="{ props }">
                              <v-text-field
                                v-model="txtEmploymentDate"
                                label="Employment Start Date"
                                :rules="[
                                  (v) =>
                                    !!v || 'Employment Start Date is required',
                                ]"
                                variant="underlined"
                                density="comfortable"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="props"
                                color="#005F95"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="pickerEmploymentDate"
                              @update:modelValue="updateEmploymentDate"
                              :max="today"
                              min="1950-01-01"
                              color="#005F95"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>

                        <!--&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&-->

                        <v-col cols="12" sm="1"></v-col>

                        <v-col cols="12" sm="3">
                          <v-select
                            v-model="dropdownoccupation"
                            :items="dropdown_occupation"
                            :rules="[
                              (v) => !!v || 'Occupation Level is required',
                            ]"
                            label="Occupation Level"
                            required
                            clearable
                            placeholder
                            color="#005F95"
                            type="text"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-briefcase"
                          ></v-select>
                        </v-col>
                      </v-row>

                      <v-row v-if="radioemployment === 'Y'" wrap>
                        <v-col cols="12" sm="3">
                          <v-text-field
                            v-model="txtOccupation"
                            label="Occupation"
                            :rules="[
                              validateField(
                                textFieldRegex,
                                'Please enter text only'
                              ),
                            ]"
                            @keyup="uppercase"
                            maxlength="50"
                            counter
                            required
                            clearable
                            color="#005F95"
                            placeholder
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-account-tie"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="1"></v-col>

                        <v-col cols="12" sm="3">
                          <v-select
                            v-model="dropdownstatus"
                            :items="dropdown_status"
                            :rules="[
                              (v) => !!v || 'Occupation Status is required',
                            ]"
                            label="Occupation Status"
                            required
                            clearable
                            color="#005F95"
                            placeholder
                            type="text"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-account-clock"
                          ></v-select>
                        </v-col>

                        <v-col cols="1"></v-col>

                        <v-col cols="12" sm="3">
                          <v-select
                            v-model="dropdownindustry"
                            :items="dropdown_industry"
                            :rules="[(v) => !!v || 'Industry is required']"
                            label="Industry"
                            required
                            clearable
                            color="#005F95"
                            placeholder
                            type="text"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-city"
                          ></v-select>
                        </v-col>
                      </v-row>

                      <v-row class="wrap">
                        <v-col cols="12" sm="3">
                          <v-select
                            v-model="dropdowntypeofincome"
                            :items="dropdown_typeofincome"
                            :rules="[
                              (v) => !!v || 'Type of Income is required',
                            ]"
                            label="Type of Income"
                            required
                            clearable
                            color="#005F95"
                            placeholder=""
                            type="text"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-credit-card"
                          ></v-select>
                        </v-col>

                        <v-col cols="1"></v-col>

                        <v-col cols="12" sm="3">
                          <v-select
                            v-model="dropdownsourceoffunds"
                            :items="dropdown_sourceoffunds"
                            :rules="[
                              (v) => !!v || 'Source Of Funds is required',
                            ]"
                            label="Source of Funds"
                            required
                            clearable
                            color="#005F95"
                            placeholder=""
                            type="text"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-wallet"
                          ></v-select>
                        </v-col>

                        <v-col cols="1"></v-col>

                        <v-col cols="12" sm="3">
                          <v-text-field
                            v-model="txtAmount"
                            label="Amount (ZAR)"
                            :rules="[
                              validateField(
                                numericFieldRegex,
                                'Please enter text only'
                              ),
                            ]"
                            prefix="R"
                            required
                            placeholder="0"
                            clearable
                            color="#005F95"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-cash"
                            mask="###############"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row v-if="counter > 0" class="wrap">
                        <v-col cols="12" sm="3">
                          <v-select
                            v-model="dropdowntypeofincome2"
                            :items="dropdown_typeofincome"
                            :rules="[
                              (v) => !!v || 'Type of Income is required',
                            ]"
                            label="Type of Income"
                            required
                            clearable
                            color="#005F95"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-credit-card"
                            placeholder=""
                            type="text"
                          ></v-select>
                        </v-col>

                        <v-col cols="1"></v-col>

                        <v-col cols="12" sm="3">
                          <v-select
                            v-model="dropdownsourceoffunds2"
                            :items="dropdown_sourceoffunds"
                            :rules="[
                              (v) => !!v || 'Source Of Funds is required',
                            ]"
                            label="Source of Funds"
                            required
                            clearable
                            color="#005F95"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-wallet"
                            placeholder=""
                            type="text"
                          ></v-select>
                        </v-col>

                        <v-col cols="1"></v-col>

                        <v-col cols="12" sm="3">
                          <v-text-field
                            v-model="txtAmount2"
                            label="Amount (ZAR)"
                            :rules="[
                              validateField(
                                numericFieldRegex,
                                'Please enter text only'
                              ),
                            ]"
                            prefix="R"
                            required
                            clearable
                            color="#005F95"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-cash"
                            placeholder="0"
                            mask="###############"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row v-if="counter > 1" class="wrap">
                        <v-col cols="12" sm="3">
                          <v-select
                            v-model="dropdowntypeofincome3"
                            :items="dropdown_typeofincome"
                            :rules="[
                              (v) => !!v || 'Type of Income is required',
                            ]"
                            label="Type of Income"
                            required
                            clearable
                            color="#005F95"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-credit-card"
                            placeholder=""
                            type="text"
                          ></v-select>
                        </v-col>

                        <v-col cols="1"></v-col>

                        <v-col cols="12" sm="3">
                          <v-select
                            v-model="dropdownsourceoffunds3"
                            :items="dropdown_sourceoffunds"
                            :rules="[
                              (v) => !!v || 'Source of Funds is required',
                            ]"
                            label="Source of Funds"
                            required
                            clearable
                            color="#005F95"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-wallet"
                            placeholder="0"
                            type="text"
                          ></v-select>
                        </v-col>

                        <v-col cols="1"></v-col>

                        <v-col cols="12" sm="3">
                          <v-text-field
                            v-model="txtAmount3"
                            label="Amount (ZAR)"
                            :rules="[
                              validateField(
                                numericFieldRegex,
                                'Please enter text only'
                              ),
                            ]"
                            prefix="R"
                            required
                            clearable
                            color="#005F95"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-cash"
                            placeholder="0"
                            mask="###############"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row v-if="counter > 2" class="wrap">
                        <v-col cols="12" sm="3">
                          <v-select
                            v-model="dropdowntypeofincome4"
                            :items="dropdown_typeofincome"
                            :rules="[
                              (v) => !!v || 'Type of Income is required',
                            ]"
                            label="Type of Income"
                            required
                            clearable
                            color="#005F95"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-credit-card"
                            placeholder=""
                            type="text"
                          ></v-select>
                        </v-col>

                        <v-col cols="1"></v-col>

                        <v-col cols="12" sm="3">
                          <v-select
                            v-model="dropdownsourceoffunds4"
                            :items="dropdown_sourceoffunds"
                            :rules="[
                              (v) => !!v || 'Source of Funds is required',
                            ]"
                            label="Source of Funds"
                            required
                            clearable
                            color="#005F95"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-wallet"
                            placeholder=""
                            type="text"
                          ></v-select>
                        </v-col>

                        <v-col cols="1"></v-col>

                        <v-col cols="12" sm="3">
                          <v-text-field
                            v-model="txtAmount4"
                            label="Amount (ZAR)"
                            :rules="[
                              validateField(
                                numericFieldRegex,
                                'Please enter text only'
                              ),
                            ]"
                            prefix="R"
                            required
                            clearable
                            color="#005F95"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-cash"
                            placeholder="0"
                            mask="###############"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row v-if="counter > 3" class="wrap">
                        <v-col cols="12" sm="3">
                          <v-select
                            v-model="dropdowntypeofincome5"
                            :items="dropdown_typeofincome"
                            :rules="[
                              (v) => !!v || 'Type of Income is required',
                            ]"
                            label="Type of Income"
                            required
                            clearable
                            color="#005F95"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-credit-card"
                            placeholder=""
                            type="text"
                          ></v-select>
                        </v-col>

                        <v-col cols="1"></v-col>

                        <v-col cols="12" sm="3">
                          <v-select
                            v-model="dropdownsourceoffunds5"
                            :items="dropdown_sourceoffunds"
                            :rules="[
                              (v) => !!v || 'Source of Funds is required',
                            ]"
                            label="Source of Funds"
                            required
                            clearable
                            color="#005F95"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-wallet"
                            placeholder=""
                            type="text"
                          ></v-select>
                        </v-col>

                        <v-col cols="1"></v-col>

                        <v-col cols="12" sm="3">
                          <v-text-field
                            v-model="txtAmount5"
                            label="Amount (ZAR)"
                            :rules="[
                              validateField(
                                numericFieldRegex,
                                'Please enter text only'
                              ),
                            ]"
                            prefix="R"
                            required
                            clearable
                            color="#005F95"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-cash"
                            placeholder="0"
                            mask="###############"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row v-if="counter < 4" class="d-flex justify-start">
                        <v-col cols="12" sm="8" class="text-left">
                          <div
                            class="d-flex align-center"
                            @click="btnaddRow"
                            style="cursor: pointer"
                          >
                            <v-icon
                              color="#ffffff"
                              style="
                                font-size: 30px;
                                background-color: #041e42;
                                border-radius: 50%;
                                padding: 10px;
                              "
                            >
                              mdi-plus
                            </v-icon>
                            <span style="margin-left: 8px; font-size: 13px"
                              >ADD INCOME ROW</span
                            >
                          </div>
                        </v-col>
                      </v-row>

                      <v-row v-if="counter > 0" class="d-flex justify-start">
                        <v-col cols="12" sm="8" class="text-left">
                          <div
                            class="d-flex align-center"
                            @click="btnremoveIncomeRow"
                            style="cursor: pointer"
                          >
                            <v-icon
                              color="#ffffff"
                              style="
                                font-size: 30px;
                                background-color: #041e42;
                                border-radius: 50%;
                                padding: 10px;
                              "
                            >
                              mdi-minus
                            </v-icon>
                            <span style="margin-left: 8px; font-size: 13px"
                              >REMOVE INCOME ROW</span
                            >
                          </div>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="6" sm="6" class="text-left">
                          <v-btn
                            color="#005F95"
                            class="white--text"
                            @click="step = 2"
                            style="border-radius: 0; width: 170px; height: 30px"
                          >
                            Previous
                          </v-btn>
                        </v-col>

                        <v-col cols="6" style="text-align: right">
                          <v-btn
                            color="#005F95"
                            class="white--text"
                            @click="updateEmployandEduInfor()"
                            style="border-radius: 0; width: 170px; height: 30px"
                            :loading="isLoading"
                            :disabled="!isEmploymentDetailsFormValid"
                          >
                            <span v-if="!isLoading">CONTINUE</span>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-container>
                </v-form>
              </v-stepper-window-item>

              <!-- ####################################################################--STEPPER 4 : CONSENT & ACCEPTANCE---########################################################################### -->

              <v-stepper-window-item :value="4">
                <v-form
                  v-model="isMarketingConsentDetailsFormValid"
                  ref="isMarketingConsentDetailsFormValid"
                  lazy-validation
                >
                  <v-container
                    fluid
                    style="
                      border: 0px solid #ccc;
                      border-radius: 0;
                      padding: 16px;
                    "
                  >
                    <v-container fluid style="border-radius: 0; padding: 16px">
                      <v-row>
                        <v-col cols="12" sm="12">
                          <h1 style="text-align: left" class="Main-Header">
                            CONSENT & ACCEPTANCE
                          </h1>
                        </v-col>
                      </v-row>

                      <v-row class="radio-group-row">
                        <v-col cols="12" sm="9">
                          <p class="section-title"><b>TELESALES</b></p>
                          <p class="section-description">
                            May we contact you telephonically to offer you
                            products and services that may benefit you?
                          </p>
                        </v-col>

                        <v-col cols="12" sm="5">
                          <v-radio-group
                            v-model="radioOtherOffers"
                            :rules="[
                              (v) =>
                                !!v || 'At least one field must be selected!',
                            ]"
                            inline
                            row
                            required
                          >
                            <v-radio
                              label="Yes"
                              value="Yes"
                              color="#005F95"
                            ></v-radio>
                            <v-radio
                              label="No"
                              value="No"
                              color="#005F95"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>
                      </v-row>

                      <v-row class="radio-group-row">
                        <v-col cols="12">
                          <p class="section-title"><b>EMAIL MARKETING</b></p>
                          <p class="section-description">
                            May we send you marketing emails to keep you up to
                            date with our latest products and services?
                          </p>
                        </v-col>

                        <v-col cols="12" sm="5">
                          <v-radio-group
                            v-model="radioEmailCampaigns"
                            :rules="[
                              (v) =>
                                !!v || 'At least one field must be selected!',
                            ]"
                            row
                            inline
                            required
                          >
                            <v-radio
                              label="Yes"
                              value="Yes"
                              color="#005F95"
                            ></v-radio>
                            <v-radio
                              label="No"
                              value="No"
                              color="#005F95"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>
                      </v-row>

                      <v-row class="radio-group-row">
                        <v-col cols="12">
                          <p class="section-title"><b>SMS MARKETING</b></p>
                          <p class="section-description">
                            May we send you marketing SMSs to keep you up to
                            date with our latest products and services?
                          </p>
                        </v-col>

                        <v-col cols="12" sm="5">
                          <v-radio-group
                            v-model="radioSMSCampaigns"
                            :rules="[
                              (v) =>
                                !!v || 'At least one field must be selected!',
                            ]"
                            row
                            inline=""
                            required
                          >
                            <v-radio
                              label="Yes"
                              value="Yes"
                              color="#005F95"
                            ></v-radio>
                            <v-radio
                              label="No"
                              value="No"
                              color="#005F95"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>
                      </v-row>

                      <v-row class="radio-group-row">
                        <v-col cols="12">
                          <p class="section-title">
                            <b>RECEIVE MARKETING</b>
                          </p>
                          <p class="section-description">
                            Let us know whether you would like to receive
                            marketing communication from us.<br />
                            <b>Note:</b> Opting out of all marketing
                            communication means that you will not always be kept
                            up to date with our latest products and services or
                            special offers.
                          </p>
                        </v-col>

                        <v-col cols="12" sm="5">
                          <v-radio-group
                            v-model="radioMarketingComms"
                            :rules="[
                              (v) =>
                                !!v || 'At least one field must be selected!',
                            ]"
                            row
                            inline
                            required
                          >
                            <v-radio
                              label="Yes"
                              value="Yes"
                              color="#005F95"
                            ></v-radio>
                            <v-radio
                              label="No"
                              value="No"
                              color="#005F95"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>
                      </v-row>

                      <v-row class="radio-group-row">
                        <v-col cols="12">
                          <p class="section-title">
                            <b>MARKETING RESEARCH</b>
                          </p>

                          <p class="section-description">
                            We would really like to get your feedback on our
                            products and services. Let us know if you would like
                            to be contacted for research purposes.
                          </p>
                        </v-col>
                        <v-col cols="12" sm="5">
                          <v-radio-group
                            v-model="radioMarketingResearch"
                            :rules="[
                              (v) =>
                                !!v || 'At least one field must be selected!',
                            ]"
                            row
                            inline
                            required
                          >
                            <v-radio
                              label="Yes"
                              value="Yes"
                              color="#005F95"
                            ></v-radio>
                            <v-radio
                              label="No"
                              value="No"
                              color="#005F95"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12">
                          <p style="text-align: left">
                            Please note that you have the right to change your
                            consent and preferences at any time in the future at
                            any branch, by contacting your relationship manager,
                            calling us on 0860 346 377 or emailing us at
                            <a
                              href="mailto:custserv@dinersclub.co.za"
                              target="_top"
                              >custserv@dinersclub.co.za</a
                            >, or logging into our banking channels to update
                            your preferences.
                          </p>
                        </v-col>

                        <v-col cols="12">
                          <p class="section-description">
                            Would you like to be notified when transacting on
                            your account?
                          </p>
                        </v-col>
                        <v-col cols="12" sm="5">
                          <v-radio-group
                            v-model="radioNotifyMe"
                            :rules="[
                              (v) =>
                                !!v || 'At least one field must be selected!',
                            ]"
                            row
                            inline
                            required
                          >
                            <v-radio
                              label="Yes"
                              value="Yes"
                              color="#005F95"
                            ></v-radio>
                            <v-radio
                              label="No"
                              value="No"
                              color="#005F95"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12">
                          <h1 style="text-align: left" class="Loyalty-Details">
                            LOYALTY DETAILS
                          </h1>
                        </v-col>

                        <v-col cols="12">
                          <p style="text-align: left">
                            Copy as provided by DCSA Consumer card explaining
                            the {{ toggleloyaltyprogram }} offering and
                            subscription fees associated:
                            <br />
                            <a
                              v-if="
                                prodtype === 'platinum' ||
                                prodtype === 'shariah'
                              "
                              target="_blank"
                              class="no-wrap"
                              href="https://clubmiles.dinersclub.co.za/"
                            >
                              Diners Club ClubMiles Website
                            </a>
                            <span v-else-if="prodtype === 'beyond'">
                              <a
                                class="no-wrap"
                                target="_blank"
                                href="assets/docs/DC-Cashback-Ts&Cs-2025.pdf"
                              >
                                Diners Club CashBack Reward Programme Terms and
                                Conditions
                              </a>
                              ,
                              <a
                                class="no-wrap"
                                target="_blank"
                                href="/assets/docs/DC-Cashback-Rewards-FAQ-2025.pdf"
                              >
                                Frequently Asked Questions (FAQs)
                              </a>

                              and

                              <a
                                class="no-wrap"
                                target="_blank"
                                href="/assets/docs/DC-Cashback-Rewards-Onepager-2025.pdf"
                              >
                                 Cashback Rewards One Pager.
                              </a>
                              
                              </span
                            >
                          </p>
                        </v-col>

                        <br />
                      </v-row>

                      <v-row>
                        <v-col cols="9">
                          <p class="section-description">
                            Would you like to be linked to the Diners Club
                            {{ toggleloyaltyprogram }} Programme?
                          </p>
                        </v-col>

                        <v-col cols="12">
                          <v-radio-group
                            v-model="radioloyaltyprogramme"
                            :rules="[
                              (v) =>
                                !!v || 'At least one field must be selected!',
                            ]"
                            row
                            inline
                            required
                          >
                            <v-radio
                              label="Yes"
                              :value="toggleloyaltyoption"
                              color="#005F95"
                            ></v-radio>
                            <v-radio
                              label="No"
                              value="N"
                              color="#005F95"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12">
                          <h1 style="text-align: left" class="Marital-Status">
                            ETHNIC GROUP
                          </h1>
                        </v-col>
                        <v-col cols="12" sm="3">
                          <v-select
                            v-model="dropdownethnicgroup"
                            :items="dropdown_ethnicgroup"
                            :rules="[(v) => !!v || 'Ethnic Group is required']"
                            label="Ethnic Group"
                            required
                            clearable
                            color="#005F95"
                            placeholder=""
                            type="text"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-account-group"
                          ></v-select>
                        </v-col>

                        <v-col cols="12">
                          <h1 style="text-align: left" class="Marital-Status">
                            MARITAL STATUS
                          </h1>
                        </v-col>
                        <v-col cols="12" sm="3">
                          <v-select
                            v-model="dropdownmaritalstatus"
                            :items="dropdown_maritalstatus"
                            :rules="[
                              (v) => !!v || 'Marital Status is required',
                            ]"
                            label="Marital Status"
                            required
                            clearable
                            color="#005F95"
                            placeholder=""
                            type="text"
                            variant="underlined"
                            density="comfortable"
                            prepend-icon="mdi-account-heart"
                            @change="ClearMarriedStatus"
                          ></v-select>
                        </v-col>

                        <v-col
                          cols="12"
                          v-if="dropdownmaritalstatus === 'MARRIED'"
                        >
                          <v-checkbox
                            v-model="check_spousalconsent"
                            value="Y"
                            required
                            color="#005F95"
                          >
                            <template #label>
                              <span id="checkboxLabel">
                                I hereby confirm that I have the relevant
                                spousal consent to enter into a credit agreement
                              </span>
                            </template>
                          </v-checkbox>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="6" sm="6" class="text-left">
                          <v-btn
                            color="#005F95"
                            class="white--text"
                            @click="step = 3"
                            style="border-radius: 0; width: 170px; height: 30px"
                          >
                            Previous
                          </v-btn>
                        </v-col>

                        <v-col cols="6" sm="6" class="text-right">
                          <v-btn
                            color="#005F95"
                            class="white--text"
                            style="border-radius: 0; width: 170px; height: 30px"
                            @click="updateMarketingConsent()"
                            :loading="isLoading"
                            :disabled="!isMarketingConsentDetailsFormValid"
                          >
                            <span v-if="!isLoading">CONTINUE</span>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-container>
                </v-form>
              </v-stepper-window-item>

              <!-- #################################################...SUPPORTING DOCUMENTS...################################################# -->
              <v-stepper-window-item :value="5">
                <!-- <v-form v-model="validSupportingDocs" lazy-validation> -->
                <v-container
                  fluid
                  style="
                    border: 0px solid #ccc;
                    border-radius: 0;
                    padding: 16px;
                  "
                >
                  <v-container fluid style="border-radius: 0; padding: 16px">
                    <v-row>
                      <v-col cols="12" sm="12">
                        <h1 style="text-align: left" class="Main-Header">
                          SUPPORTING DOCUMENTS
                        </h1>
                      </v-col>
                    </v-row>

                    <v-col cols="12">
                      <p style="text-align: left">
                        Please upload the following documents in support of your
                        application. Please note the following when uploading
                        file: <br />
                        - That only the following file types are supported:
                        .PDF<br />
                        - File size is limited to 4MB per item.
                      </p>
                    </v-col>

                    <!-- ********************...IDENTITY DOCUMENT...********************* -->

                    <v-col cols="12" style="text-align: left">
                      <p style="text-align: left">
                        <b>IDENTITY DOCUMENT</b>
                      </p>
                    </v-col>

                    <v-row wrap>
                      <v-col cols="12" sm="3" style="text-align: left">
                        <input
                          type="file"
                          accept="application/pdf"
                          id="IdFileUpload"
                          ref="IdFileUpload"
                          name="IdFileUpload"
                          @change="handleIDFileUpload"
                        />

                        <div id="message" v-if="fileerrormessage !== null">
                          <v-col
                            v-if="fileerrormessage === 'Invalid File Format'"
                          >
                            <p style="color: red">{{ invalidFileFormat }}</p>
                          </v-col>
                        </div>
                      </v-col>

                      <v-col cols="12" sm="4"></v-col>

                      <v-col cols="12" sm="1">
                        <v-btn
                          value="IdentityDocument"
                          @click="submitIDFile('IdentityDocument')"
                          name="IdFileUpload"
                          type="submit"
                          small
                          class="button"
                          style="
                            border-radius: 0;
                            min-width: 120px;
                            height: 25px;
                          "
                        >
                          {{ idbutton }}
                        </v-btn>
                      </v-col>
                    </v-row>

                    <!-- ********************...PROOF OF RESIDENCE...********************* -->

                    <v-col cols="12" style="text-align: left">
                      <p>
                        <b
                          >PROOF OF RESIDENCE E.G. UTILITY BILL (NOT OLDER THAN
                          3 MONTHS)</b
                        >
                      </p>
                    </v-col>

                    <v-row wrap>
                      <v-col cols="12" sm="3" style="text-align: left">
                        <!-- File input for proof of residence (PDF only) -->
                        <input
                          type="file"
                          accept="application/pdf"
                          id="PORFileUpload"
                          ref="PORFileUpload"
                          name="PORFileUpload"
                          @change="handlePORFileUpload"
                        />

                        <!-- Error message displayed if file format is invalid -->
                        <div id="message" v-if="fileerrormessage !== null">
                          <v-col
                            v-if="fileerrormessage === 'Invalid File Format'"
                          >
                            <p style="color: red">{{ invalidFileFormat }}</p>
                          </v-col>
                        </div>
                      </v-col>

                      <v-col cols="12" sm="4"></v-col>
                      <!-- Empty space for layout -->

                      <v-col cols="12" sm="1">
                        <!-- Submit button that triggers file submission -->
                        <v-btn
                          value="ProofOfResidence"
                          @click="submitPORFile('ProofOfResidence')"
                          name="PORFileUpload"
                          type="submit"
                          small
                          class="button"
                          style="
                            border-radius: 0;
                            min-width: 120px;
                            height: 25px;
                          "
                        >
                          {{ resbutton }}
                          <!-- Display the button text -->
                        </v-btn>
                      </v-col>
                    </v-row>

                    <!-- ********************...LAST 3 MONTHS BANK STATEMENTS...********************* -->

                    <v-col cols="12" style="text-align: left">
                      <p>
                        <b>LAST 3 MONTHS BANK STATEMENTS</b>
                      </p>
                    </v-col>

                    <v-row wrap>
                      <v-col cols="12" sm="3" style="text-align: left">
                        <!-- File input for Bank Statement (PDF only) -->
                        <input
                          type="file"
                          accept="application/pdf"
                          id="BankStateFileUpload"
                          ref="BankStateFileUpload"
                          name="BankStateFileUpload"
                          @change="handleBankFileUpload"
                        />

                        <!-- Error message displayed if file format is invalid -->
                        <div id="message" v-if="fileerrormessage !== null">
                          <v-col
                            v-if="fileerrormessage === 'Invalid File Format'"
                          >
                            <p style="color: red">{{ invalidFileFormat }}</p>
                          </v-col>
                        </div>
                      </v-col>

                      <v-col cols="12" sm="4"></v-col>
                      <!-- Empty space for layout -->

                      <v-col cols="12" sm="1">
                        <!-- Submit button that triggers file submission -->
                        <v-btn
                          value="BankStatement"
                          @click="submitBankFile('BankStatement')"
                          name="BankStateFileUpload"
                          type="submit"
                          small
                          class="button"
                          style="
                            border-radius: 0;
                            min-width: 120px;
                            height: 25px;
                          "
                        >
                          {{ bankbutton }}
                          <!-- Display the button text -->
                        </v-btn>
                      </v-col>
                    </v-row>

                    <!-- ********************...LATEST PAYSLIP...********************* -->

                    <v-col cols="12" style="text-align: left">
                      <p>
                        <b>LATEST PAYSLIP</b>
                      </p>
                    </v-col>

                    <v-row wrap>
                      <v-col cols="12" sm="3" style="text-align: left">
                        <!-- File input for Latest Payslip (PDF only) -->
                        <input
                          type="file"
                          accept="application/pdf"
                          id="PaySlipFileUpload"
                          ref="PaySlipFileUpload"
                          name="PaySlipFileUpload"
                          @change="handlePaySlipFileUpload"
                        />

                        <!-- Error message displayed if file format is invalid -->
                        <div id="message" v-if="fileerrormessage !== null">
                          <v-col
                            v-if="fileerrormessage === 'Invalid File Format'"
                          >
                            <p style="color: red">{{ invalidFileFormat }}</p>
                          </v-col>
                        </div>
                      </v-col>

                      <v-col cols="12" sm="4"></v-col>
                      <!-- Empty space for layout -->

                      <v-col cols="12" sm="1">
                        <!-- Submit button that triggers file submission -->
                        <v-btn
                          value="PaySlip"
                          @click="submitPaySlipFile('PaySlip')"
                          name="PaySlipFileUpload"
                          type="submit"
                          small
                          class="button"
                          style="
                            border-radius: 0;
                            min-width: 120px;
                            height: 25px;
                          "
                        >
                          {{ payslipbutton }}
                          <!-- Display the button text -->
                        </v-btn>
                      </v-col>
                    </v-row>

                    <!-- ********************...ITA34TAX DOCUMENT...********************* -->

                    <v-col cols="12" style="text-align: left">
                      <p>
                        <b
                          >IF YOU HAVE YOUR OWN BUSINESS AN ITA 34TAX ASSESSMENT
                          FORM IS REQUIRED</b
                        >
                      </p>
                    </v-col>

                    <v-row wrap>
                      <v-col cols="12" sm="3" style="text-align: left">
                        <!-- File input for Latest Payslip (PDF only) -->
                        <input
                          type="file"
                          accept="application/pdf"
                          id="ITA34TaxFileUpload"
                          ref="ITA34TaxFileUpload"
                          name="ITA34TaxFileUpload"
                          @change="handleITA34FileUpload"
                        />

                        <!-- Error message displayed if file format is invalid -->
                        <div id="message" v-if="fileerrormessage !== null">
                          <v-col
                            v-if="fileerrormessage === 'Invalid File Format'"
                          >
                            <p style="color: red">{{ invalidFileFormat }}</p>
                          </v-col>
                        </div>
                      </v-col>

                      <v-col cols="12" sm="4"></v-col>
                      <!-- Empty space for layout -->

                      <v-col cols="12" sm="1">
                        <!-- Submit button that triggers file submission -->
                        <v-btn
                          value="ITA34Tax"
                          @click="submitITA34File('ITA34Tax')"
                          name="ITA34TaxFileUpload"
                          type="submit"
                          small
                          class="button"
                          style="
                            border-radius: 0;
                            min-width: 120px;
                            height: 25px;
                          "
                        >
                          {{ itabutton }}
                          <!-- Display the button text -->
                        </v-btn>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12">
                        <p style="text-align: left">
                          You may send the relevant documents to
                          <a
                            href="mailto:supporting.docs@dinersclub.co.za"
                            target="_top"
                          >
                            supporting.docs@dinersclub.co.za
                          </a>
                          , and please quote the reference number:
                          <strong>[{{ refNumber }}]</strong>
                        </p>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="6" sm="6" class="text-left">
                        <v-btn
                          color="#005F95"
                          class="white--text"
                          @click="goToPrevious"
                          style="border-radius: 0; width: 170px; height: 30px"
                        >
                          Previous
                        </v-btn>
                      </v-col>

                      <v-col cols="6" sm="6" class="text-right">
                        <v-btn
                          color="#005F95"
                          class="white--text"
                          @click="checkidtype()"
                          style="border-radius: 0; width: 170px; height: 30px"
                          :loading="isLoading"
                        >
                          <span v-if="!isLoading">CONTINUE</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-container>
                <!-- </v-form> -->
              </v-stepper-window-item>

              <!-- #################################################...DPF VIEW...######################################################### -->

              <v-stepper-window-item :value="6">
                <v-form v-model="validSupportingDocs" lazy-validation>
                  <v-container
                    fluid
                    style="
                      border: 0px solid #ccc;
                      border-radius: 0;
                      padding: 16px;
                    "
                  >
                    <v-container fluid style="border-radius: 0; padding: 16px">
                      <v-row>
                        <v-col cols="12" sm="12">
                          <h1 style="text-align: left" class="Main-Header">
                            PDF VIEW
                          </h1>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <v-card
                            style="border-radius: 0"
                            class="mx-auto"
                            max-width="1500"
                          >
                            <v-container class="ng-scope pdfobject-container">
                              <iframe
                                v-if="pdfUrl"
                                :src="pdfUrl"
                                width="100%"
                                height="600px"
                              ></iframe>
                            </v-container>
                          </v-card>

                          <v-row class="mt-3">
                            <v-col xs2 sm3 class="text-left">
                              <!-- Add content here if needed -->
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row v-if="prodtype === 'shariah'">
                        <v-col cols="12">
                          <v-checkbox
                            v-model="check_PAQStateandQuote"
                            :value="'Yes'"
                            color="#005F95"
                            :rules="[(v) => !!v || 'This field is required!']"
                            required
                            hide-details
                          >
                            <template #label>
                              <span id="checkboxLabel">
                                I understand that the Diners Club Shari'ah Card
                                is subject to certain terms and conditions. To
                                read these terms and conditions,
                                <a
                                  class="no-wrap"
                                  target="_blank"
                                  @click.stop
                                  href="https://dinersclub.co.za/wp-content/uploads/2021/08/Shariah-TsCs-2021.pdf"
                                >
                                  Click here.
                                </a>
                              </span>
                            </template>
                          </v-checkbox>
                        </v-col>
                      </v-row>

                      <v-row v-if="prodtype === 'platinum'">
                        <v-col :cols="12">
                          <v-checkbox
                            v-model="check_PAQStateandQuote"
                            :value="'Yes'"
                            color="#005F95"
                            :rules="[(v) => !!v || 'This field is required!']"
                            required
                            hide-details
                          >
                            <template #label>
                              <span id="checkboxLabel">
                                I understand that the Diners Club Credit Card is
                                subject to certain terms and conditions. To read
                                these terms and conditions,
                                <a
                                  class="no-wrap"
                                  target="_blank"
                                  @click.stop
                                  href="/assets/docs/DC_Credit_Card_Ts&Cs_2026.pdf"  rel="noopener noreferrer"
                                >
                                  Click here.
                                </a>
                              </span>
                            </template>
                          </v-checkbox>
                        </v-col>
                      </v-row>

                      <v-row v-if="prodtype === 'beyond'">
                        <v-col :cols="12">
                          <v-checkbox
                            v-model="check_PAQStateandQuote"
                            :value="'Yes'"
                            color="#005F95"
                            :rules="[(v) => !!v || 'This field is required!']"
                            required
                            hide-details
                          >
                            <template #label>
                              <span id="checkboxLabel">
                                I understand that the Diners Club Beyond Card is
                                subject to certain terms and conditions. To read
                                these terms and conditions,
                                <a
                                  class="no-wrap"
                                  target="_blank"
                                  @click.stop
                                  href="/assets/docs/DC_Credit_Card_Ts&Cs_2026.pdf" rel="noopener noreferrer"
                                >
                                  Click here.
                                </a>
                              </span>
                            </template>
                          </v-checkbox>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12">
                          <!-- First Checkbox: Membership Fee Terms -->
                          <v-checkbox
                            v-model="check_CardFeesTCs"
                            value="Yes"
                            color="#005F95"
                            :rules="[(v) => !!v || 'This field is required!']"
                            row
                            required
                            hide-details
                          >
                            <template v-slot:label>
                              <span id="checkboxLabel">
                                I understand that a monthly membership fee will
                                be charged by Diners Club to participate in the
                                Diners Club benefits program and that the Diners
                                Club benefits program is subject to certain
                                terms and conditions. To read these terms and
                                conditions
                                <a
                                  class="no-wrap"
                                  target="_blank"
                                  @click.stop
                                  href="https://dinersclub.co.za/wp-content/uploads/2020/01/Membership_Agree_TC_2018.pdf"
                                >
                                  Click here.
                                </a>
                                I further understand that I will not be able to
                                proceed with this application if I do not accept
                                to pay the monthly membership fee.
                              </span>
                            </template>
                          </v-checkbox>
                        </v-col>

                        <v-col cols="12">
                          <!-- Second Checkbox: True and Correct Information Declaration -->
                          <v-checkbox
                            v-model="check_TrueandCorrectInfor"
                            light
                            value="Yes"
                            color="#005F95"
                            :rules="[(v) => !!v || 'This field is required!']"
                            row
                            required
                            hide-details
                          >
                            <template v-slot:label>
                              <span id="checkboxLabel">
                                I declare to the best of my knowledge and belief
                                that the particulars as set out in this
                                application form are true and correct and that
                                no additional information that may influence
                                Diners Club SA (Pty) Ltd has been withheld by
                                me.
                              </span>
                            </template>
                          </v-checkbox>
                        </v-col>
                      </v-row>

                      <v-row class="text-left">
                        <v-col cols="12">
                          <p>
                            Should you wish to not participate in the Diners
                            Club benefits program and pay the membership fee,
                            you will not be eligible for the Diners product.
                            However, you may apply for a Standard Bank blue
                            credit card with no benefits program attached at
                            <a
                              class="no-wrap"
                              target="_blank"
                              href="https://www.standardbank.co.za"
                            >
                              www.standardbank.co.za
                            </a>
                          </p>
                        </v-col>

                        <v-col cols="12">
                          <p>
                            You can go back to the previous screen to reduce the
                            spend limit
                          </p>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col class="text-center">
                          <v-btn
                            color="#005F95"
                            class="white--text"
                            @click="goToPrevious"
                            style="width: 135px; height: 30px; border-radius: 0"
                          >
                            Go Back
                          </v-btn>
                        </v-col>

                        <v-col cols="12" sm="1"></v-col>

                        <v-col class="text-center">
                          <v-btn
                            color="#005F95"
                            class="white--text"
                            @click="PendOfferSts()"
                            style="width: 135px; height: 30px; border-radius: 0"
                            :loading="isLoading"
                          >
                            <span v-if="!isLoading">Pend Offer</span>
                          </v-btn>
                        </v-col>

                        <v-col cols="12" sm="1"></v-col>

                        <v-col class="text-center">
                          <v-btn
                            color="#005F95"
                            class="white--text"
                            @click="DeclineOfferSts()"
                            style="width: 135px; height: 30px; border-radius: 0"
                            :loading="isLoading"
                          >
                            <span v-if="!isLoading">Decline Offer</span>
                          </v-btn>
                        </v-col>

                        <v-col cols="12" sm="1"></v-col>

                        <!-- &&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&& -->

                        <v-col class="text-center">
                          <v-btn
                            color="#005F95"
                            class="white--text"
                            @click="sign_dialog = true"
                            v-on:click="AcceptOfferSts()"
                            style="width: 135px; height: 30px; border-radius: 0"
                            :loading="isLoading"
                            :disabled="!isPAQDetailsFormValid"
                          >
                            <span v-if="!isLoading">Accept Offer</span>
                          </v-btn>
                        </v-col>
                      </v-row>

                      <v-dialog
                        v-model="sign_dialog"
                        persistent
                        max-width="500"
                      >
                        <v-card :style="{ borderRadius: '0px' }">
                          <v-toolbar color="#005F95">
                            <v-toolbar-title row wrap class="text-center"
                              ><p class="Dialog-Wording">
                                SIGN LEGAL AGREEMENT
                              </p></v-toolbar-title
                            >
                          </v-toolbar>

                          <v-container hide-details>
                            <v-card-text>
                              <p>
                                By Clicking "<b>Sign</b>" you confirm that you
                                have read, understood, accept, and sign the
                                {{ agreeprodtype }} Agreement and Membership
                                Agreement.
                              </p>
                              <p class="Sign-OTP" style="text-align: center">
                                ENTER YOUR ONE-TIME PASSWORD
                              </p>

                              <v-col
                                cols="12"
                                md="12"
                                class="text-center d-flex justify-center"
                              >
                                <v-text-field
                                  v-for="(digit, index) in otp"
                                  :key="index"
                                  ref="otpRefs"
                                  v-model="otp[index]"
                                  maxlength="1"
                                  class="otp-box"
                                  type="text"
                                  variant="outlined"
                                  @input="handleInput(index, $event)"
                                  @keydown.delete="
                                    handleBackspace(index, $event)
                                  "
                                />
                              </v-col>

                              <!--************---If the OTP is not Expired---********** -->

                              <v-col>
                                <!-- OTP Sent Message -->
                                <div v-if="!expired" class="text-center">
                                  OTP sent to: [{{ maskedCell }}]
                                </div>

                                <!-- Resend OTP Link -->
                                <div v-else class="text-center">
                                  <p style="text-align: center">
                                    <a
                                      v-if="!otpresent"
                                      href="#"
                                      @click.prevent="resendPAQOTP()"
                                      >Resend OTP?</a
                                    >
                                  </p>
                                </div>

                                <!-- OTP Timer -->
                                <div
                                  ref="timerRef"
                                  id="time"
                                  class="text-center"
                                >
                                  <p
                                    id="warning"
                                    v-if="!expired || otpresent"
                                    class="text-center"
                                  >
                                    You have {{ otpTime }} to enter your OTP
                                  </p>
                                </div>

                                <!--************---If Response Messages From the Back End is either "OTP_Wrong or TempBlock"---********** -->

                                <div
                                  id="message"
                                  v-if="!respMessageExpire"
                                  class="text-center"
                                  style="text-align: center"
                                >
                                  <p
                                    id="message"
                                    style="text-align: center"
                                    v-if="respMessage === 'OTP_wrong'"
                                  >
                                    {{ message }}
                                  </p>
                                  <p
                                    id="message"
                                    style="text-align: center"
                                    v-if="respMessage === 'TempBlock'"
                                  >
                                    {{ message }}
                                  </p>
                                </div>
                              </v-col>
                            </v-card-text>

                            <v-row>
                              <v-col style="text-align: left">
                                <v-btn
                                  class="white--text"
                                  color="#005F95"
                                  style="
                                    border-radius: 0;
                                    width: 120px;
                                    height: 30px;
                                  "
                                  @click="sign_dialog = false"
                                >
                                  Back
                                </v-btn></v-col
                              >

                              <v-col style="text-align: right">
                                <v-btn
                                  class="white--text"
                                  color="#005F95"
                                  style="
                                    border-radius: 0;
                                    width: 120px;
                                    height: 30px;
                                  "
                                  @click="otpValidation()"
                                  :loading="isLoading"
                                  :disabled="!isOTPEntered"
                                >
                                  <span v-if="!isLoading">Sign</span>
                                </v-btn></v-col
                              ></v-row
                            >
                          </v-container>
                        </v-card>
                      </v-dialog>
                    </v-container>
                  </v-container>
                </v-form>
              </v-stepper-window-item>
            </v-stepper-window>
          </v-stepper>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
,
<script setup>
/* eslint-disable */

import { useDisplay } from "vuetify/lib/framework.mjs";
import { ref, computed, onMounted, onBeforeMount, watch, nextTick } from "vue";
import { useRouter } from "vue-router";
import axios from "axios"; // Import axios if not globally available
// import jwtAxios from "../auth/jwt"

const { smAndDown, mdAndUp, lgAndUp } = useDisplay();
const isSmall = smAndDown;
const isMedium = computed(() => mdAndUp.value && !lgAndUp.value);
const isLarge = lgAndUp;
const startnewapp = ref("");
const BeyondSelected = ref(false);
const product = ref("");
const prodtype = ref("");
const appStatus = ref("");
const apptype = ref("");
const refNumber = ref("");
const creditGranted = ref(0);
const pdfUrl = ref("");

const step = ref(1);
const grantedCreditLimit = ref(null);
const agreeprodtype = ref("");
const router = useRouter();

const maxDate = ref(new Date().toISOString().split("T")[0]); // Format as YYYY-MM-DD
const today = new Date().toISOString().split("T")[0];
const minDate = ref("1950-01-01");

// Banking Details Declarations
const debitorder_dialog = ref(false);
const manualpayment_dialog = ref(false);
const shariah_dialog = ref(false);
const sign_dialog = ref(false);
const shariah = ref("");
const debitorder_disagree = ref("");
const debitorder_agree = ref("");
const manualpayment = ref("");
const radiodebitorder = ref(null);

// const radiodebitorder = ref('Y');
const dropdownbank = ref("");
const dropdownacctype = ref("");
const dropdowndebitday = ref("");
const txtBranchcode = ref("");
const txtAccount = ref("");
const dropdown_bank = ref([
  "Absa Bank",
  "Bank of Athens",
  "Standard Bank",
  "SA Post Bank",
  "Nedbank",
  "Investec Private Bank",
  "FNB",
  "Capitec Bank",
  "Bidvest Bank",
]);
const dropdown_acctype = ref([]);
const dropdown_debitday = ref([
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
]);
const validBanking = ref("");
// Address Information
const txtAddress1 = ref("");
const txtAddress2 = ref("");
const txtSuburb = ref("");
const txtCity = ref("");
const txtCode = ref("");
const dropdownProvince = ref("");

const txtPAddress1 = ref("");
const txtPAddress2 = ref("");
const txtPSuburb = ref("");
const txtPCity = ref("");
const txtPCode = ref("");
const dropdownPProvince = ref("");
const dropdownCountryOfResidentialAddress = ref("");
const dropdownCountryOfPostalAddress = ref("");
const check_PostalAddress = ref();
const isLoading = ref(false);
const dropdown_province = ref([
  "GAUTENG",
  "LIMPOPO",
  "MPUMALANGA",
  "EASTERN CAPE",
  "FREE STATE",
  "NORTH WEST",
  "WESTERN CAPE",
  "KWAZULU-NATAL",
  "NORTHERN CAPE",
]);
const dropdown_CountryOfResidentialAddress = ref([]); //Data is pulled from the GTS Table
const dropdown_CountryOfPostalAddress = ref([]); //Data is pulled from the GTS Table

//GT VAlue List ID
const valueQualificationid = ref("022010");
const valueOccupationid = ref("019910");
const valueStatusid = ref("058010");
const valueIndustryid = ref("040010");
const valueBankid = ref("005010");
const valueBranchid = ref("071210");
const valueAccoutTypeid = ref("019410");
const valueSpouseid = ref("074510");
const valueMaritalStatusid = ref("002810");
const valueCountryid = ref("076110");
const valueEthnicgroupid = ref("019810");
const valueFundssource = ref("076210");
const valueIncometype = ref("044010");

// Employment Information
const validEmployment = ref(true);
const validSupportingDocs = ref(true);
validSupportingDocs;
const txtEmployer = ref("");
// const employmentdate = ref("");
const dropdownoccupation = ref("");
const dropdownqualification = ref("");
const radioemployment = ref("");
const dropdown_occupation = ref([]); // Data is pulled from the GTS Table
const txtOccupation = ref(""); // Stores the user's occupation text input
const dropdownstatus = ref(""); // Holds selected occupation status
const dropdownindustry = ref(""); // Holds selected industry
const dropdown_status = ref(["Full-Time", "Part-Time", "Contract", "Intern"]); // Replace with actual options
const dropdown_industry = ref([]); // Data is pulled from the GTS Table

const dropdowntypeofincome = ref(""); // Selected type of income
const dropdownsourceoffunds = ref(""); // Selected source of funds
const txtAmount = ref(""); // Amount in ZAR
const dropdown_typeofincome = ref([]); // Data is pulled from the GTS Table
const dropdown_sourceoffunds = ref([]); // Data is pulled from the GTS Table

const dropdowntypeofincome2 = ref("");
const dropdownsourceoffunds2 = ref("");
const txtAmount2 = ref("");

const dropdowntypeofincome3 = ref("");
const dropdownsourceoffunds3 = ref("");
const txtAmount3 = ref("");

const dropdowntypeofincome4 = ref("");
const dropdownsourceoffunds4 = ref("");
const txtAmount4 = ref("");

const dropdowntypeofincome5 = ref("");
const dropdownsourceoffunds5 = ref("");
const txtAmount5 = ref("");

const loadercolor = ref("#ffffff");
const size = ref(24);

//Employment Date Picker
const menuEmploymentDate = ref(false);
const txtEmploymentDate = ref("");
const pickerEmploymentDate = ref(null);

//Consent and Acceptance Form Input Declaration
const radioOtherOffers = ref("");
const radioEmailCampaigns = ref("");
const radioSMSCampaigns = ref("");
const radioMarketingComms = ref("");
const radioMarketingResearch = ref("");
const radioNotifyMe = ref("");
const radioloyaltyprogramme = ref("");
const dropdownethnicgroup = ref("");
const dropdownmaritalstatus = ref("");
const check_spousalconsent = ref("");
const dropdown_ethnicgroup = ref(["Group A", "Group B", "Group C"]);
const dropdown_maritalstatus = ref([
  "SINGLE",
  "MARRIED",
  "DIVORCED",
  "WIDOWED",
]);

//Supporting Documents
const fileerrormessage = ref("");
const validDocuments = ref(false);
// const validMarketing = ref(false);
const validAddress = ref(false);
const invalidFileFormat = ref(
  "Invalid file format. Only PDF files are accepted."
);
const idbutton = ref("Submit"); // Button text for submission
const resbutton = ref("Submit"); // Button text for submission
const bankbutton = ref("Submit"); // Button text for submissi
const payslipbutton = ref("Submit"); // Button text for submission itabutton
const itabutton = ref("Submit"); // Button text for submission
const IdFileUpload = ref(null);
const PORFileUpload = ref(null); // Proof Of Residency
const BankStateFileUpload = ref(null);

const PaySlipFileUpload = ref(null);
const ITA34TaxFileUpload = ref(null);

const idmessage = ref("");
const check_PaylSlipandBankstate = ref("");
const check_PAQStateandQuote = ref("");
const check_CardFeesTCs = ref("");
const check_TrueandCorrectInfor = ref("");
const statusAPIvalue = ref("");
const sendOPT = ref("Yes");
const signPAQ = ref("NotSigned");
const counter = ref(0);
const maskedCell = ref("");
// const incompleteRef = ref(sessionStorage.getItem('incompleteRef'));
const incompleteRef = ref(sessionStorage.getItem("incompleteRef"));

const expired = ref(false);
const otpresent = ref(false);
const error = ref(false);
const message = ref("");
const respMessage = ref("");
const toggleloyaltyprogram = ref("");
const toggleloyaltyoption = ref("");
const respMessageExpire = ref(false);
const resentOTPMessage = ref("");
const respMessageFAIL = ref("OTP Invalid");
const time = ref(""); // Example countdown

const otp = ref(["", "", "", "", "", ""]);
const otpRefs = ref([]);

const paqcellnumber = ref("");
const paqfirstname = ref("");
const paqlastname = ref("");
const paqsaid = ref("");
const paqdelioption = ref("");
const paqaddress1 = ref("");
const paqsuburb = ref("");
const paqaddress2 = ref("");
const paqprovince = ref("");
const paqcity = ref("");
const paqcode = ref("");

// Reusable validateField rule generator:
const validateField = (pattern, errorMessage) => {
  return (v) => {
    if (!v) return "This field is required";
    return pattern.test(v) || errorMessage;
  };
};

// Regex Patterns
const textFieldRegex = /^[A-Za-z\s]+$/;
const textFieldSpaceRegex = /^[ A-Za-z0-9_@./#&+-]*$/;
const textFieldHyphenRegex = /^[a-zA-Z\- s]+$/;
const alphaNumericFieldRegex = /^[a-zA-Z0-9\- s]+$/;
const numericFieldRegex = /^[0-9]*$/;
const contactFieldRegex = /^[0-9]{10}$/;
const emailAddressRegex = /^[\w-\.]+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}/;
//Mobile Responsiveness Function

// Create a reactive variable to track if the screen size is mobile
const isMobile = ref(window.innerWidth <= 600);

// Watch the window resize event to update isMobile
const updateMobileStatus = () => {
  isMobile.value = window.innerWidth <= 600;
};

watch(isMobile, () => {
  // Optionally, you can handle other state changes here if needed
  console.log("Screen size changed, is mobile:", isMobile.value);
});

onMounted(() => {
  // Add event listener on mounted to track window resize
  window.addEventListener("resize", updateMobileStatus);
  updateMobileStatus(); // Initial check

  // Auto-focus first box when dialog opens
  // sign_dialog.value = true;
  nextTick(() => {
    otpRefs.value[0]?.focus();
  });
});

//Form Field Validations - Banking Details Form
const isBankingDetailsFormValid = computed(() => {
  if (radiodebitorder.value === "Y") {
    return (
      dropdownbank.value?.trim() !== "" &&
      txtBranchcode.value?.trim() !== "" &&
      txtAccount.value?.trim() !== "" &&
      dropdownacctype.value?.trim() !== "" &&
      dropdowndebitday.value?.trim() !== ""
    );
  } else if (radiodebitorder.value === "N") {
    return true;
  }
  return false;
});

//Form Field Validations - Residential and Postal Details Form
const isResandPostDetailsFormValid = computed(() => {
  const baseFieldsComplete =
    txtAddress1.value?.trim() !== "" &&
    txtAddress2.value?.trim() !== "" &&
    dropdownProvince.value?.trim() !== "" &&
    txtSuburb.value?.trim() !== "" &&
    txtCity.value?.trim() !== "" &&
    txtCode.value?.trim() !== "" &&
    dropdownCountryOfResidentialAddress.value?.trim() !== "";
  // dropdownCountryOfPostalAddress.value?.trim() !=="";

  if (check_PostalAddress.value === "Y") {
    return baseFieldsComplete;
  } else {
    return (
      baseFieldsComplete &&
      // check_PostalAddress.value !== "" &&
      dropdownCountryOfPostalAddress.value?.trim() !== "" &&
      txtPAddress1.value?.trim() !== "" &&
      txtPAddress2.value?.trim() !== "" &&
      dropdownPProvince.value?.trim() !== "" &&
      txtPSuburb.value?.trim() !== "" &&
      txtPCity.value?.trim() !== "" &&
      txtPCode.value?.trim() !== ""
    );
  }
});

//Form Field Validations - Employment Details Form
const isEmploymentDetailsFormValid = computed(() => {
  if (radioemployment.value === "Y") {
    return (
      radioemployment.value?.trim() !== "" &&
      txtEmployer.value?.trim() !== "" &&
      dropdownoccupation.value?.trim() !== "" &&
      dropdownstatus.value?.trim() !== "" &&
      txtEmploymentDate.value?.trim() !== "" &&
      txtOccupation.value?.trim() !== "" &&
      dropdownindustry.value?.trim() !== "" &&
      dropdowntypeofincome.value?.trim() !== "" &&
      dropdownsourceoffunds.value?.trim() !== "" &&
      txtAmount.value?.trim() !== ""
    );
  } else if (radioemployment.value === "N") {
    return radioemployment.value?.trim() !== "";
  }
  return false;
});

//Form Field Validations - OTP Form
const isOTPEntered = computed(() => {
  return otp.value.every((digit) => digit.trim() !== "");
});

//Form Field Validations - Marketing Consent Details Form
const isMarketingConsentDetailsFormValid = computed(() => {
  const isCommonValid =
    radioEmailCampaigns.value?.trim() !== "" &&
    // radioSMSCampigns.value?.trim() !== '' &&
    radioMarketingComms.value?.trim() !== "" &&
    radioMarketingResearch.value?.trim() !== "" &&
    radioOtherOffers.value?.trim() !== "" &&
    radioNotifyMe.value?.trim() !== "" &&
    radioloyaltyprogramme.value?.trim() !== "" &&
    dropdownmaritalstatus.value?.trim() !== "" &&
    dropdownethnicgroup.value?.trim() !== "";

  if (dropdownmaritalstatus.value !== "MARRIED") {
    return isCommonValid;
  } else {
    return isCommonValid && check_spousalconsent.value;
  }
});

//Form Field Validations - File Upload Form
const isFileUploadFormValid = computed(() => {
  return (
    IdentityDocument.value &&
    BankStatement.value &&
    ProofOfResidence.value &&
    PaySlip.value
  );
});

//Form Field Validations - PAQ Details Form
const isPAQDetailsFormValid = computed(() => {
  return (
    check_PAQStateandQuote.value &&
    check_CardFeesTCs.value &&
    check_TrueandCorrectInfor.value
  );
});

onBeforeMount(() => {
  prodtype.value = sessionStorage.getItem("prodtype");
  apptype.value = sessionStorage.getItem("apptype");
  appStatus.value = sessionStorage.getItem("appStatus");

  if (apptype.value === "newapp") {
    refNumber.value = sessionStorage.getItem("refNumber");
  } else if (apptype.value === "continueapp") {
    refNumber.value = sessionStorage.getItem("incompleteRef");
  }

  // Clean up the event listener before component unmounts
  window.removeEventListener("resize", updateMobileStatus);

  // Redirect based on appStatus
  if (["Declined", "Approved", "Referred"].includes(appStatus.value)) {
    router.push("/ApplicationList");
    return;
  }
  check_PostalAddress.value = "N";
  console.log(check_PostalAddress.value);

  // Determine product type using switch
  switch (prodtype.value) {
    case "platinum":
      product.value = "CREDIT CARD";
      agreeprodtype.value = "Credit Card";
      break;
    case "shariah":
      product.value = "SHARI'AH CARD";
      agreeprodtype.value = "Shari'ah Card";
      break;
    default:
      product.value = "BEYOND CARD";
      agreeprodtype.value = "Beyond Card";
      BeyondSelected.value = true;
      break;
  }

  if (prodtype.value === "beyond") {
    toggleloyaltyprogram.value = "CashBack Reward";
    toggleloyaltyoption.value = "K";
  } else {
    toggleloyaltyprogram.value = "ClubMiles Loyalty";
    toggleloyaltyoption.value = "C";
  }

  funcvalidateuser();

  console.log("NewApp Comp: ", apptype.value);

  if (apptype.value === "newapp") {
    console.log("Inside AppType Check: ", apptype.value);
    getGTSValueData();

    if (refNumber.value != null) {
      GetUserForReferenceNumber();
    }

    if (sessionStorage.getItem("IDType") === "Passport") {
      step.value = 1;
    }

    // PUT IT BACK AFTER APPROVED LIMIT SCREED IS ADDED
    // grantedlimit.value = sessionStorage.getItem("creditLimit");
    // if (grantedlimit.value !== null) {
    //   reducedLimit();
    // }
  } else if (apptype.value === "continueapp" && refNumber.value != null) {
    if (
      ["Referred", "Approved", "Declined", "Pending"].includes(appStatus.value)
    ) {
      router.push("/ApplicationList");
    } else if (appStatus.value === "Incomplete") {
      getGTSValueData();
      GetUserForReferenceNumber();
      getBankingDetails();
      getResandPostAddressInfor();
      getEmployandEduInfor();
      getMarketingConsent();
      getLoyaltyDetails();

      if (sessionStorage.getItem("IDType") === "Passport") {
        step.value = 1;
      }
      // grantedlimit.value = sessionStorage.getItem("creditLimit");
    }
  } else {
    router.push("/");
  }
});

// Methods (define your actual implementations for these)
const funcvalidateuser = async () => {
  try {
    const response = await axios.post("/validateuser", {
      _USERID: sessionStorage.getItem("userid"),
      _REFNUMBER: refNumber.value,
    });
    console.log("Validation successful:", response.data);
    // Add any further processing of the response data here
  } catch (error) {
    console.error("Error validating user:", error);
  }
};

const getGTSValues = async (ValueListID) => {
  if (dropdown_occupation.value === null) {
    console.log("Value List ID Was Not Found");
    return;
  }

  try {
    const response = await axios.post("/getGTSValueList", {
      _SEQ_P: ValueListID,
    });

    // Filter out empty strings from the array
    const filteredValues = response.data.data._VALARR.filter(
      (value) => value.trim() !== ""
    );

    // Ensure the filtered array has elements before proceeding
    if (filteredValues.length === 0) {
      console.log("No valid values found after filtering.");
      return;
    }

    const value = filteredValues[0];

    switch (value) {
      case "DIRECTOR":
        dropdown_occupation.value = filteredValues;
        break;
      case "FULL TIME":
        dropdown_status.value = filteredValues;
        break;
      case "AGRICULTURE":
        dropdown_industry.value = filteredValues;
        break;
      case "Salary / Wage Income":
        dropdown_sourceoffunds.value = filteredValues;
        break;
      case "SALARY":
        dropdown_typeofincome.value = filteredValues;
        break;
      case "ASIAN":
        dropdown_ethnicgroup.value = filteredValues;
        break;
      case "CO-HABITING":
        dropdown_maritalstatus.value = filteredValues;
        break;
      case "SOUTH AFRICA":
        dropdown_CountryOfResidentialAddress.value = filteredValues;
        dropdown_CountryOfPostalAddress.value = filteredValues;
        break;
      // case "STANDARD BANK":
      //   dropdown_bank.value = filteredValues;
      //   break;
      case "SAVINGS ACCOUNT":
        dropdown_acctype.value = filteredValues;
        break;
        // case "ABSA BANK":
        // dropdown_branch .value = filteredValues;
        break;
      // default:
      //   console.log("Unhandled value:", value);
      //   break;
    }
  } catch (error) {
    console.error("Error fetching GTS values:", error);
    // alert("Error fetching GTS values");
  }
};

const getGTSValueData = () => {
  // getGTSValues(valueQualificationid.value);
  getGTSValues(valueOccupationid.value);
  getGTSValues(valueStatusid.value);
  getGTSValues(valueIndustryid.value);
  getGTSValues(valueBankid.value);
  getGTSValues(valueBranchid.value);
  getGTSValues(valueAccoutTypeid.value);
  getGTSValues(valueFundssource.value);
  getGTSValues(valueIncometype.value);
  getGTSValues(valueSpouseid.value);
  getGTSValues(valueMaritalStatusid.value);
  getGTSValues(valueCountryid.value);
  getGTSValues(valueEthnicgroupid.value);
};

const GetUserForReferenceNumber = () => {
  axios
    .post("/GetUserForReferenceNumber", {
      _REFNUMBER: refNumber.value,
    })
    .then((response) => {
      if (response.data.data._USERID !== null) {
        // Handle the case where _USERID is not null
        console.log(response.data.data._USERID);
        // sessionStorage.setItem("userId", response.data.data._USERID)
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

//********************************---Method to fetch banking details---**********************************************
const getBankingDetails = async () => {
  const token = sessionStorage.getItem("authToken");

  if (!incompleteRef.value && !token) {
    console.log("User not Authorized");
    isLoading.value = false;
    return;
  }

  try {
    const response = await axios.post(
      "/getBankingDetails",
      {
        _REFNUMBER: incompleteRef.value,
      },
      {
        headers: {
          Authorization: token, // Pass the auth token in headers
        },
      }
    );

    // Update reactive variables
    radiodebitorder.value = response.data.data._DEBITORDER;
    dropdownbank.value = response.data.data._BANKNAME;
    txtBranchcode.value = response.data.data._BRANCHCODE;
    txtAccount.value = response.data.data._ACCNUMBER;
    dropdownacctype.value = response.data.data._ACCTYPE;
    dropdowndebitday.value = response.data.data._DEBITDAY;
    debitorder_agree.value = response.data.data._AGREED;
  } catch (error) {
    console.error("Error fetching banking details:", error);
  } finally {
    isLoading.value = false;
  }
};

//&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&---Method to fetch residential and postal address info---&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
const getResandPostAddressInfor = async () => {
  const token = sessionStorage.getItem("authToken");

  if (!incompleteRef.value && !token) {
    console.log("User not Authorized");
    isLoading.value = false;
    return;
  }

  try {
    const response = await axios.post(
      "/getResandPostAddressInfor",
      { _REFNUMBER: incompleteRef.value },
      {
        headers: {
          Authorization: token, // Pass the auth token in headers
        },
      }
    );

    // Update reactive variables
    txtAddress1.value = response.data.data._RESADDLINE1;
    txtAddress2.value = response.data.data._RESADDLINE2;
    dropdownProvince.value = response.data.data._RESADDLINE3;
    txtSuburb.value = response.data.data._RESSUBURB;
    txtCity.value = response.data.data._RESTOWN;
    txtCode.value = response.data.data._RESPOSTCODE;

    txtPAddress1.value = response.data.data._POSTADDLINE1;
    txtPAddress2.value = response.data.data._POSTADDLINE2;
    dropdownPProvince.value = response.data.data._POSTADDLINE3;
    txtPSuburb.value = response.data.data._POSTSUBURB;
    txtPCity.value = response.data.data._POSTTOWN;
    txtPCode.value = response.data.data._POSTPOSTCODE;

    check_PostalAddress.value = response.data.data._ADDSAME;
    dropdownCountryOfResidentialAddress.value = response.data.data._RESCOUNTRY;
    dropdownCountryOfPostalAddress.value = response.data.data._POSTCOUNTRY;
  } catch (error) {
    console.error("Error fetching address info:", error);
  } finally {
    isLoading.value = false;
  }
};

//%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%---Fetch employment and education info---%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%

// const getDateYYYYMMDD = (date) => {
//   return date ? new Date(date).toISOString().split("T")[0] : "";
// };

const formatDateToDashed = (dateStr) => {
  if (!dateStr || dateStr.length !== 8) return "";
  const year = dateStr.slice(0, 4);
  const month = dateStr.slice(4, 6);
  const day = dateStr.slice(6, 8);
  return `${year}-${month}-${day}`;
};

const getEmployandEduInfor = async () => {
  const token = sessionStorage.getItem("authToken");

  if (!incompleteRef.value && !token) {
    console.log("Customer Reference Number or Auth Token Not Found");
    isLoading.value = false;
    return;
  }

  try {
    const response = await axios.post(
      "/getEmployandEduInfor",
      { _REFNUMBER: incompleteRef.value },
      {
        headers: {
          Authorization: token, // Passing auth token in headers
        },
      }
    );

    const data = response.data.data;

    dropdownqualification.value = data._HIGHESTQUAL || "";
    radioemployment.value = data._EMPLOYED || "";
    txtEmployer.value = data._CURREMPLOYER || "";
    dropdownoccupation.value = data._OCCLEVEL || "";
    dropdownstatus.value = data._OCCSTATUS || "";
    txtOccupation.value = data._OCCUPATION || "";
    dropdownindustry.value = data._INDUSTRY || "";
    dropdowntypeofincome.value = data._TYPEINCOME1 || "";
    dropdownsourceoffunds.value = data._SOURCEFUNDS1 || "";
    txtAmount.value = data._AMOUNT1 || "";
    dropdowntypeofincome2.value = data._TYPEINCOME2 || "";
    dropdownsourceoffunds2.value = data._SOURCEFUNDS2 || "";
    txtAmount2.value = data._AMOUNT2 || "";
    dropdowntypeofincome3.value = data._TYPEINCOME3 || "";
    dropdownsourceoffunds3.value = data._SOURCEFUNDS3 || "";
    txtAmount3.value = data._AMOUNT3 || "";
    dropdowntypeofincome4.value = data._TYPEINCOME4 || "";
    dropdownsourceoffunds4.value = data._SOURCEFUNDS4 || "";
    txtAmount4.value = data._AMOUNT4 || "";
    dropdowntypeofincome5.value = data._TYPEINCOME5 || "";
    dropdownsourceoffunds5.value = data._SOURCEFUNDS5 || "";
    txtAmount5.value = data._AMOUNT5 || "";
    // Handle employment date
    if (data._EMPSTARTDATE === "NA" || data._EMPSTARTDATE === "") {
      txtEmploymentDate.value = "1950-01-01";
    } else {
      txtEmploymentDate.value = formatDateToDashed(data._EMPSTARTDATE);
    }
  } catch (error) {
    console.error("Error fetching employment & education info:", error);
  } finally {
    isLoading.value = false;
  }
};

//%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%---Fetch Marketing Consent info---%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%

const getMarketingConsent = async () => {
  const token = sessionStorage.getItem("authToken");

  if (!incompleteRef.value && !token) {
    console.log("User not Authorized");
    isLoading.value = false;
    return;
  }

  try {
    const response = await axios.post(
      "/getMarketing",
      { REFNUMBER: incompleteRef.value },
      {
        headers: {
          Authorization: token, // Pass the auth token in headers
        },
      }
    );

    const data = response.data.data;

    // Update reactive variables
    radioEmailCampaigns.value = data.EMAILCAMPAIGNS;
    radioSMSCampaigns.value = data.SMSCAMPAIGNS;
    radioOtherOffers.value = data.OTHEROFFERS;
    radioNotifyMe.value = data.NOTIFYME;
    // radioInAppMsgs.value = data.INAPPMSGS;
    radioMarketingComms.value = data.MARKCOMMS;
    radioMarketingResearch.value = data.MARKRESEARCH;
  } catch (error) {
    console.error("Error fetching marketing consent:", error);
  } finally {
    isLoading.value = false;
  }
};

//%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%---Fetch Loyalty Program Details---%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%

const getLoyaltyDetails = async () => {
  const token = sessionStorage.getItem("authToken");

  if (!incompleteRef.value && !token) {
    console.log("User not Authorized");
    isLoading.value = false;
    return;
  }

  try {
    const response = await axios.post(
      "/getLoyaltyDetails",
      { _REFNUMBER: incompleteRef.value },
      {
        headers: {
          Authorization: token, // Pass the auth token in headers
        },
      }
    );

    const data = response.data.data;

    // Update reactive variables
    radioloyaltyprogramme.value = data._LOYALTY;
    dropdownmaritalstatus.value = data._MARITALSTATUS;
    check_spousalconsent.value = data._SPOUSECONSENT;
    dropdownethnicgroup.value = data._ETHNICGROUP;
  } catch (error) {
    console.error("Error fetching loyalty details:", error);
  } finally {
    isLoading.value = false;
  }
};

const reducedLimit = () => {
  // Logic to reduce limit
};

// Computed property to check if product type is Shariah
const isShariahProduct = computed(() => prodtype.value === "shariah");

// Watcher to handle radio selection changes
watch(radiodebitorder, (newValue) => {
  if (newValue === "Y") {
    if (isShariahProduct.value) {
      shariah_dialog.value = true; // Show only Shariah Dialog
    } else {
      debitorder_dialog.value = true; // Show Debit Order Dialog for non-Shariah products
    }
  } else if (newValue === "N") {
    manualpayment_dialog.value = true;
  }
});

// const debitorderYes = () => {
//   console.log('Customer Said "YES" to Debit order')
//   radiodebitorder.value = "Y";
//   Shariahcheck();
// };
// const debitorderNo = () => {
//   console.log('Customer Said "NO" to Debit order')
//   radiodebitorder.value = "N";
// };
// const Shariahcheck = () => {
//   if (prodtype.value === "shariah") {
//     shariah_dialog.value = true;
//   }
// };

const branchCodes = () => {
  console.log("Inside branch code function");
  // Placeholder function for branch code logic

  switch (dropdownbank.value) {
    case "Absa Bank":
      txtBranchcode.value = "632005";
      break;
    case "Bank of Athens":
      txtBranchcode.value = "410506";
      break;
    case "Standard Bank":
      txtBranchcode.value = "051001";
      break;
    case "SA Post Bank":
      txtBranchcode.value = "460005";
      break;
    case "Nedbank":
      txtBranchcode.value = "198765";
      break;
    case "Investec Private Bank":
      txtBranchcode.value = "580105";
      break;
    case "FNB":
      txtBranchcode.value = "254005";
      break;
    case "Capitec Bank":
      txtBranchcode.value = "470010";
      break;
    case "Bidvest Bank":
      txtBranchcode.value = "462005";
      break;
    default:
      txtBranchcode.value = ""; // Clear the branch code if no match is found
      console.log("Unknown bank selected:", dropdownbank.value);
      break;
  }
};

// Helper function to format date as YYYY-MM-DD
const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const updateEmploymentDate = (newDate) => {
  nextTick(() => {
    pickerEmploymentDate.value = new Date(newDate);
    txtEmploymentDate.value = formatDate(pickerEmploymentDate.value); // Format the date
    menuEmploymentDate.value = false; // Close the menu after selecting a date
  });
};
// Function for input to uppercase
const uppercase = () => {
  console.log("inside uppercase - employment");
  txtEmployer.value = txtEmployer.value.toUpperCase();
  txtOccupation.value = txtOccupation.value.toUpperCase();
  txtAddress1.value = txtAddress1.value.toUpperCase();
  txtAddress2.value = txtAddress2.value.toUpperCase();
  txtSuburb.value = txtSuburb.value.toUpperCase();
  txtCity.value = txtCity.value.toUpperCase();

  txtPAddress1.value = txtPAddress1.value.toUpperCase();
  txtPAddress2.value = txtPAddress2.value.toUpperCase();
  txtPSuburb.value = txtPSuburb.value.toUpperCase();
  txtPCity.value = txtPCity.value.toUpperCase();
};

const ClearMarriedStatus = () => {
  if (dropdownmaritalstatus.value !== "MARRIED") {
    check_spousalconsent.value = "";
  }
};

// Function to add an income row
const btnaddRow = () => {
  counter.value++;
};

// Function to remove an income row
const btnremoveIncomeRow = () => {
  if (counter.value > 0) {
    counter.value--;
  }
};

// Function to clear address details if postal address is the same
const ClearAddressDetails = () => {
  if (check_PostalAddress.value === "Y") {
    dropdownCountryOfPostalAddress.value = "";
  } else {
    check_PostalAddress.value = "N";
  }
};

//***********************************************************************--Function OTP Functionalities--*******************************************************************
// Handle input and auto-move to next field
const handleInput = (index, event) => {
  if (event.inputType === "deleteContentBackward") return;

  if (event.target.value.match(/^\d$/)) {
    otp.value[index] = event.target.value;

    // Move to the next field
    if (index < 5) {
      nextTick(() => {
        otpRefs.value[index + 1]?.focus();
      });
    }
  } else {
    otp.value[index] = ""; // Ensure only numbers
  }
};

// Handle backspace and move to previous field
const handleBackspace = (index, event) => {
  if (!otp.value[index]) {
    if (index > 0) {
      nextTick(() => {
        otpRefs.value[index - 1]?.focus();
      });
    }
  }
};

//***********************************************************************--Function to update banking details--*******************************************************************
const updateBankingDetails = async () => {
  const token = sessionStorage.getItem("authToken");

  isLoading.value = true;

  if (!refNumber.value && !token) {
    console.log("User not Authorized");
    isLoading.value = false;
    router.push("/TechnicalError");
    return;
  } else {
    try {
      const response = await axios.post(
        "/updateBankingDetails",
        {
          _REFNUMBER: refNumber.value,
          _DEBITORDER: radiodebitorder.value,
          _BANKNAME: dropdownbank.value,
          _BRANCHNAME: "NA",
          _BRANCHCODE: txtBranchcode.value,
          _ACCNUMBER: txtAccount.value,
          _ACCTYPE: dropdownacctype.value,
          _DEBITDAY: dropdowndebitday.value,
          _AGREED: radiodebitorder.value,
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );

      if (response.status !== 200) {
        isLoading.value = false;
        router.push("/TechnicalError");
      } else {
        isLoading.value = false;
        if (
          response.data.data._RESPONSE === "UPDATED" ||
          response.data.data._RESPONSE === "ADDED"
        ) {
          GetUserForReferenceNumber();
          step.value = 2;
        }
      }
    } catch (error) {
      console.log(error);
      isLoading.value = false;
      router.push("/TechnicalError");
    }
  }
};

//*****************************************--Function to update residential and postal address info--****************************************************

const updateResandPostAddressInfor = async () => {
  const token = sessionStorage.getItem("authToken");

  isLoading.value = true;

  if (!refNumber.value && !token) {
    console.log("Customer Authentication Failed");
    isLoading.value = false;
    router.push("/TechnicalError");
    return;
  } else {
    try {
      const response = await axios.post(
        "/updateResandPostAddressInfor",
        {
          _REFNUMBER: refNumber.value,
          _RESADDLINE1: txtAddress1.value,
          _RESADDLINE2: txtAddress2.value,
          _RESADDLINE3: dropdownProvince.value,
          _RESSUBURB: txtSuburb.value,
          _RESTOWN: txtCity.value,
          _RESPOSTCODE: txtCode.value,
          _ADDSAME: check_PostalAddress.value,
          _RESCOUNTRY: dropdownCountryOfResidentialAddress.value,
          _POSTCOUNTRY: dropdownCountryOfPostalAddress.value,
          _POSTADDLINE1: txtPAddress1.value,
          _POSTADDLINE2: txtPAddress2.value,
          _POSTADDLINE3: dropdownPProvince.value,
          _POSTSUBURB: txtPSuburb.value,
          _POSTTOWN: txtPCity.value,
          _POSTPOSTCODE: txtPCode.value,
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );

      if (response.status !== 200) {
        isLoading.value = false;
        router.push("/TechnicalError");
      } else {
        isLoading.value = false;
        if (
          response.data.data._RESPONSE === "UPDATED" ||
          response.data.data._RESPONSE === "ADDED"
        ) {
          // this.getAppstatPersonalInfor()
          GetUserForReferenceNumber();
          step.value = 3;
        }
      }
    } catch (error) {
      console.log(error);
      isLoading.value = false;
      router.push("/TechnicalError");
    }
  }
};

//************************************************--Function to update employment and education info--******************************************************
const formatDateYYYYMMDD = (date) => {
  return date
    ? new Date(date).toISOString().split("T")[0].replace(/-/g, "")
    : "";
};
const updateEmployandEduInfor = async () => {
  console.log("Inside Employment Function");

  const token = sessionStorage.getItem("authToken");
  let txtEmployDate = "";

  isLoading.value = true;

  if (!refNumber.value && !token) {
    console.log("User not Authorized");
    isLoading.value = false;
    router.push("/TechnicalError");
  } else {
    if (radioemployment.value === "Y") {
      txtEmployDate = new Date(txtEmploymentDate.value)
        .toISOString()
        .slice(0, 10)
        .replace(/-/g, "");
    } else {
      txtEmploymentDate.value = "1950-01-01";
    }
    try {
      const response = await axios.post(
        "/updateEmployandEduInfor",
        {
          _REFNUMBER: refNumber.value,
          _HIGHESTQUAL: dropdownqualification.value,
          _EMPLOYED: radioemployment.value,
          _CURREMPLOYER: txtEmployer.value,
          _OCCLEVEL: dropdownoccupation.value,
          _OCCSTATUS: dropdownstatus.value,
          _EMPSTARTDATE: txtEmployDate,
          _OCCUPATION: txtOccupation.value,
          _INDUSTRY: dropdownindustry.value,
          _TYPEINCOME1: dropdowntypeofincome.value,
          _SOURCEFUNDS1: dropdownsourceoffunds.value,
          _AMOUNT1: parseInt(txtAmount.value),
          _TYPEINCOME2: dropdowntypeofincome2.value,
          _SOURCEFUNDS2: dropdownsourceoffunds2.value,
          _AMOUNT2: parseInt(txtAmount2.value),
          _TYPEINCOME3: dropdowntypeofincome3.value,
          _SOURCEFUNDS3: dropdownsourceoffunds3.value,
          _AMOUNT3: parseInt(txtAmount3.value),
          _TYPEINCOME4: dropdowntypeofincome4.value,
          _SOURCEFUNDS4: dropdownsourceoffunds4.value,
          _AMOUNT4: parseInt(txtAmount4.value),
          _TYPEINCOME5: dropdowntypeofincome5.value,
          _SOURCEFUNDS5: dropdownsourceoffunds5.value,
          _AMOUNT5: parseInt(txtAmount5.value),
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );

      if (response.status !== 200) {
        isLoading.value = false;
        router.push("/TechnicalError");
      } else {
        if (
          response.data.data._RESPONSE === "UPDATED" ||
          response.data.data._RESPONSE === "ADDED"
        ) {
          GetUserForReferenceNumber();

          if (sessionStorage.getItem("IDType") === "RSA ID") {
            powercurvefraudCall();
          } else {
            isLoading.value = false;
            step.value = 4;
          }
        }
      }
    } catch (error) {
      console.log(error);
      isLoading.value = false;
      router.push("/TechnicalError");
    }
  }
};

//************************************************-- Helper Function for Powercurve Fraud Check--******************************************************

const powercurvefraudCall = async () => {
  const token = sessionStorage.getItem("authToken");

  if (!refNumber.value && !token) {
    console.log("User not Authorized");
    isLoading.value = false;
    router.push("/TechnicalError");
    return;
  } else {
    const PCRef = refNumber.value.replace(/[^0-9]/g, "");
    const chargeOffDate = sessionStorage.getItem("chargeoffdate") || "19990101";
    const idType =
      sessionStorage.getItem("IDType") === "RSA ID" ? "FS0001" : "FS0002";
    const productType =
      prodtype.value === "platinum"
        ? "ZDPC"
        : prodtype.value === "shariah"
        ? "ZDSC"
        : "ZDBC";

    try {
      const response = await axios.post(
        "/powercurvefraudCall",
        {
          cust_PCData: {
            FeGenAoRef: PCRef,
            FeGenCustNo: sessionStorage.getItem("partyid"),
            FeGenIdType: idType,
            FeGenIdNo: sessionStorage.getItem("id"),
            CpmCustTitle: "",
            CpmCustInitial: sessionStorage.getItem("initials"),
            CpmCustFirstNam: sessionStorage.getItem("firstname"),
            CpmCustSurNam: sessionStorage.getItem("surname"),
            CpmCustDatOfBirth: sessionStorage.getItem("DateofBirth"),
            CpmCustGender: sessionStorage.getItem("gender"),

            CpmCustAddResLine1: txtAddress1.value,
            CpmCustAddResLine2: txtAddress2.value,
            CpmCustAddResSubrb: txtSuburb.value,
            CpmCustAddResCity: txtCity.value,
            CpmCustAddResPoCod: txtCode.value,

            CpmCustCountryOfBirth: "",
            CpmCustNationality: "",
            CpmCustCountryOfRes: "",

            CpmCustTelCellNo: sessionStorage.getItem("contact"),
            CpmCustEmail: sessionStorage.getItem("emailaddress"),
            CpmCustGrossmnthlyincme: sessionStorage.getItem("totgross"),
            FeGenLoanPurpose: "",
            AppPGrossIncme: sessionStorage.getItem("totgross"),
            AffPNetIncme: sessionStorage.getItem("netincome"),
            AffPTotIncme: sessionStorage.getItem("totincome"),
            AffPTotMnthlyExpenses: sessionStorage.getItem("expenses"),
            FeGenPrdCatgTyp: productType,
            FeGenReqLimRevdat: chargeOffDate,
            FeGenLockType: sessionStorage.getItem("withdrwancode"),
            FeGenExesRevdat: sessionStorage.getItem("withdrwandate"),
          },
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );

      const data = response.data;
      console.log(response.status);

      if (response.status === 200) {
        // console.log("response.status is 200");
        creditGranted.value = sessionStorage.getItem("grantedCreditLimit");
        
        if (creditGranted.value <= 1000 || data.FrdRollDecisionCod === "R") {
          //ASK GLEN TO DUPLICATE THE API AND RENAME- powercurveFraudData
          powercurveData();
          isLoading.value = false;
          router.push("/DeclinedApp");
        } else {
          sessionStorage.setItem("frdrolldecisioncod", data.FrdRollDecisionCod);
          sessionStorage.setItem(
            "frdrolldecisioncod1",
            data.FrdRollDeclineCod1
          );
          await getPersonalInforPDF();
          await getResandPostAddressInforPDF();
          powercurveData();
          isLoading.value = false;
          step.value = 4;
        }
      } else {
        console.log("response.status is not 200");
        isLoading.value = false;
        // Handle unexpected status codes
        console.error(`Unexpected response status: ${response.status}`);
        console.error(`Response data: ${JSON.stringify(response.data)}`);

        // Route to TechnicalError
        router.push("/TechnicalError");
      }
    } catch (error) {
      if (error.response) {
        // The server responded with a status other than 2xx
        console.error(`API Error: ${error.response.status}`);
        console.error(`Response data: ${JSON.stringify(error.response.data)}`);

        // Handle different HTTP status codes
        switch (error.response.status) {
          case 400:
            console.error("Bad Request: Check the request data.");
            break;
          case 401:
            console.error("Unauthorized: Unauthorized User.");
            break;
          case 500:
            console.error("Server Error: Try again later.");
            break;
          default:
            console.error("An error occurred: ", error.response.status);
            break;
        }
        // Route to TechnicalError
        isLoading.value = false;
        router.push("/TechnicalError");
      } else {
        console.log(error);
        // Route to TechnicalError
        isLoading.value = false;
        router.push("/TechnicalError");
      }
    }
  }
};

//************************************************-- Helper Function To Store Powercurve Fraud Check Response--******************************************************

const powercurveData = async () => {
  const token = sessionStorage.getItem("authToken");

  if (!refNumber.value && !token) {
    console.log("User not Authorized");

    return;
  } else {
    try {
      const response = await axios.post(
        "/powercurveData",
        {
          REFNUMBER: refNumber.value,
          PCREFNUMBER: sessionStorage.getItem("pcrefnumb"),
          FEGENAOREF: sessionStorage.getItem("fegenaoref"),
          FEGENCUSTNO: sessionStorage.getItem("partyid"),
          FINTOTMAXINS: sessionStorage.getItem("fintotmaxins"),
          FINMAXLIMIT: sessionStorage.getItem("grantedCreditLimit"),
          FINDECISION: sessionStorage.getItem("finprddecisioncod"),
          FINDECLCODE1: sessionStorage.getItem("finprddeclinecod1"),
          FINDECLCODE2: sessionStorage.getItem("finprddeclinecod2"),
          FRDDECISION: sessionStorage.getItem("frdrolldecisioncod"),
          FRDDECLINE: sessionStorage.getItem("frdrolldecisioncod1"),
          DECLREASON: "",
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );

      if (
        response.data.data.RESPONSE === "UPDATED" ||
        response.data.data.RESPONSE === "ADDED"
      ) {
        console.log("Fraud record has been stored");
      }
    } catch (error) {
      console.error(error);
    }
  }
};

//@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@----Additional helper functions to create and download PAQ----@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

const getPersonalInforPDF = async () => {
  const token = sessionStorage.getItem("authToken");

  if (!refNumber.value && !token) {
    console.log("User not Authorized");
    isLoading.value = false;
    return;
  }

  try {
    const response = await axios.post(
      "/getPersonalInfor",
      { _REFNUMBER: refNumber.value },
      {
        headers: {
          Authorization: token, // Pass the auth token in headers
        },
      }
    );

    const data = response.data.data;

    // Update reactive variables
    paqcellnumber.value = data._TELEPHONE;
    paqfirstname.value = data._FIRSTNAME;
    paqlastname.value = data._SURNAME;
    paqsaid.value = data._IDNUMBER;

    // Store in sessionStorage
    sessionStorage.setItem("userid", data._EMAIL);
    sessionStorage.setItem("paqcellnumber", data._TELEPHONE);
    sessionStorage.setItem("paqfirstname", data._FIRSTNAME);
    sessionStorage.setItem("paqlastname", data._SURNAME);
    sessionStorage.setItem("paqsaid", data._IDNUMBER);
    sessionStorage.setItem("passport", data._PASSPORT);
    sessionStorage.setItem("paqdelioption", data._LEGAL_DOC);
    sessionStorage.setItem("dob", data._DATEOFBIRTH);
    sessionStorage.setItem("gender", data._GENDER);
  } catch (error) {
    console.error("Error fetching personal info:", error);
  } finally {
    isLoading.value = false; // Stop isLoading state
  }
};

const getResandPostAddressInforPDF = async () => {
  const token = sessionStorage.getItem("authToken");

  if (!refNumber.value && !token) {
    console.log("User not Authorized");
    isLoading.value = false;
    return;
  }

  try {
    const response = await axios.post(
      "/getResandPostAddressInfor",
      { _REFNUMBER: refNumber.value },
      {
        headers: {
          Authorization: token, // Pass the auth token in headers
        },
      }
    );

    const data = response.data.data;

    // Update reactive variables
    paqaddress1.value = data._RESADDLINE1;
    paqsuburb.value = data._RESSUBURB;
    paqaddress2.value = data._RESADDLINE2;
    paqprovince.value = data._RESADDLINE3;
    paqcity.value = data._RESTOWN;
    paqcode.value = data._RESPOSTCODE;

    // Store in sessionStorage
    sessionStorage.setItem("paqaddress1", data._RESADDLINE1);
    sessionStorage.setItem("paqsuburb", data._RESSUBURB);
    sessionStorage.setItem("paqaddress2", data._RESADDLINE2);
    sessionStorage.setItem("paqprovince", data._RESADDLINE3);
    sessionStorage.setItem("paqcity", data._RESTOWN);
    sessionStorage.setItem("paqcode", data._RESPOSTCODE);
  } catch (error) {
    console.error("Error fetching address info:", error);
  } finally {
    isLoading.value = false;
  }
};

const limitAccepted = sessionStorage.getItem("limitaccepted");
const fintotmaxins = sessionStorage.getItem("fintotmaxins");

const generateSignedCustomerPDF = async () => {
  const token = sessionStorage.getItem("authToken");

  if (!refNumber.value && !token) {
    console.log("User Not Authorized");
    isLoading.value = false;
    return;
  }

  // 🚀 Fire request WITHOUT await
  axios.post(
    "/createCustomerPAQ",
    {
      _REFNUMBER: refNumber.value,
      _FIRSTNAME: paqfirstname.value,
      _SURNAME: paqlastname.value,
      _TELEPHONENUMBER: paqcellnumber.value,
      _IDNUMBER: paqsaid.value,
      _RESADDLINE1: paqaddress1.value,
      _RESSUBURB: paqsuburb.value,
      _RESADDLINE2: paqaddress2.value,
      _RESTOWN: paqcity.value,
      _RESADDLINE3: paqprovince.value,
      _LIMITACC: limitAccepted,
      _SURPLUS: parseInt(fintotmaxins),
      _PAQ_STATUS: statusAPIvalue.value,
      _LEGAL_DOC: paqdelioption.value,
      producttype: prodtype.value,
    },
    {
      headers: {
        Authorization: token,
      },
    }
  ).then(() => {
    console.log("PDF generation triggered");
  }).catch((error) => {
    console.error("PDF trigger failed:", error);
  });
};

// const generateSignedCustomerPDF = async () => {
//   const token = sessionStorage.getItem("authToken");

//   if (!refNumber.value && !token) {
//     console.log("User Not Authorized");
//     isLoading.value = false;
//     return;
//   }

//   try {
//     const response = await axios.post(
//       "/createCustomerPAQ",
//       {
//         _REFNUMBER: refNumber.value,
//         _FIRSTNAME: paqfirstname.value,
//         _SURNAME: paqlastname.value,
//         _TELEPHONENUMBER: paqcellnumber.value,
//         _IDNUMBER: paqsaid.value,
//         _RESADDLINE1: paqaddress1.value,
//         _RESSUBURB: paqsuburb.value,
//         _RESADDLINE2: paqaddress2.value,
//         _RESTOWN: paqcity.value,
//         _RESADDLINE3: paqprovince.value,
//         _LIMITACC: limitAccepted,
//         _SURPLUS: parseInt(fintotmaxins),
//         _PAQ_STATUS: statusAPIvalue.value,
//         _LEGAL_DOC: paqdelioption.value,
//         producttype: prodtype.value,
//       },
//       {
//         headers: {
//           Authorization: token, // Pass the auth token in headers
//         },
//       }
//     );

//     if (response.status === 200) {
//       // Success response
//       console.log("Customer PDF successfully generated.");
//       // this.getCustomerPDFlink();
//     } else {
//       // Handle unexpected status codes
//       console.error(`Unexpected response status: ${response.status}`);
//       console.error(`Response data: ${JSON.stringify(response.data)}`);
//     }
//   } catch (error) {
//     isLoading.value = false;
//     if (error.response) {
//       // The server responded with a status other than 2xx
//       console.error(`API Error: ${error.response.status}`);
//       console.error(`Response data: ${JSON.stringify(error.response.data)}`);
//     } else {
//       console.log(error);
//     }
//   }
// };

const generateSignedShariahPDF = async () => {
  const token = sessionStorage.getItem("authToken");

  if (!refNumber.value && !token) {
    console.log("User Not Authorized");
    return;
  }

  try {
    const response = await axios.post(
      "/createCustomerShariahPAQ",
      {
        _REFNUMBER: refNumber.value,
        _FIRSTNAME: paqfirstname.value,
        _SURNAME: paqlastname.value,
        _TELEPHONENUMBER: paqcellnumber.value,
        _IDNUMBER: paqsaid.value,
        _RESADDLINE1: paqaddress1.value,
        _RESSUBURB: paqsuburb.value,
        _RESADDLINE2: paqaddress2.value,
        _RESTOWN: paqcity.value,
        _RESADDLINE3: paqprovince.value,
        _LIMITACC: limitAccepted,
        _SURPLUS: parseInt(fintotmaxins),
        _PAQ_STATUS: statusAPIvalue.value,
        _LEGAL_DOC: paqdelioption.value,
        producttype: prodtype.value,
      },
      {
        headers: {
          Authorization: token, // Pass the auth token in headers
        },
      }
    );

    if (response.status === 200) {
      // Success response
      console.log("Customer PDF successfully generated.");
      // this.getCustomerPDFlink();
    } else {
      // Handle unexpected status codes
      console.log("Unable to Generate Customer PDF successfully");
      console.error(`Unexpected response status: ${response.status}`);
      console.error(`Response data: ${JSON.stringify(response.data)}`);
    }
  } catch (error) {
    if (error.response) {
      // The server responded with a status other than 2xx
      console.error(`API Error: ${error.response.status}`);
      console.error(`Response data: ${JSON.stringify(error.response.data)}`);
    } else {
      console.log(error);
      isLoading.value = false;
      router.push("/TechnicalError");
    }
  }
};

const generateCustomerPDF = async () => {
  const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
  console.log("Inside Generate Customer PDF");

  const token = sessionStorage.getItem("authToken");

  if (!refNumber.value && !token) {
    console.log("User Not Authorized");

    return;
  }

  try {
    const response = await axios.post(
      "/createCustomerPAQ",
      {
        _REFNUMBER: refNumber.value,
        _FIRSTNAME: paqfirstname.value,
        _SURNAME: paqlastname.value,
        _TELEPHONENUMBER: paqcellnumber.value,
        _IDNUMBER: paqsaid.value,
        _RESADDLINE1: paqaddress1.value,
        _RESSUBURB: paqsuburb.value,
        _RESADDLINE2: paqaddress2.value,
        _RESTOWN: paqcity.value,
        _RESADDLINE3: paqprovince.value,
        _LIMITACC: limitAccepted,
        _SURPLUS: parseInt(fintotmaxins),
        _PAQ_STATUS: statusAPIvalue.value,
        _LEGAL_DOC: paqdelioption.value,
        producttype: prodtype.value,
      },
      {
        headers: {
          Authorization: token, // Pass the auth token in headers
        },
      }
    );

    if (response.status === 200) {
      if (
        response.data.data ==
        "Customer Instalment is Greater than or Equals the Surplus"
      ) {
        isLoading.value = false;
        router.push("/DeclinedApp");
      } else {
        // Success
        console.log("Customer PDF successfully generated.");
        isLoading.value = false;
        step.value = 5;
        await delay(1000); // ⏳ wait 2 seconds
        getCustomerPDFlink();
      }
    } else {
      // Handle unexpected status codes
      console.log("Unable to Generate Customer PDF successfully");
      console.error(`Unexpected response status: ${response.status}`);
      console.error(`Response data: ${JSON.stringify(response.data)}`);
      isLoading.value = false;
      router.push("/TechnicalError");
    }
  } catch (error) {
    if (error.response) {
      // The server responded with a status other than 2xx
      console.error(`API Error: ${error.response.status}`);
      console.error(`Response data: ${JSON.stringify(error.response.data)}`);
      isLoading.value = false;
      router.push("/TechnicalError");
    } else {
      console.log(error);
      isLoading.value = false;
      router.push("/TechnicalError");
    }
  }
};

//^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^PDF VIEW^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^

const getCustomerPDFlink = async () => {
  // const paqStatus = sessionStorage.getItem("statusAPIvalue");
  const token = sessionStorage.getItem("authToken");

  const headers = {
    Authorization: token,
  };

  if (!refNumber.value && !token) {
    console.error("User not Unauthorized");
    isLoading.value = false;
    router.push("/TechnicalError");
    return;
  }

  try {
    const response = await axios.post(
      "/getCustomerPAQ",
      {
        _REFNUMBER: refNumber.value,
        _PAQ_STATUS: statusAPIvalue.value,
      },
      { headers, responseType: "blob" }
    );

    if (response.data) {
      const blob = new Blob([response.data], { type: "application/pdf" });
      pdfUrl.value = URL.createObjectURL(blob);
    } else {
      console.error("No PDF data received.");
      isLoading.value = false;
      router.push("/TechnicalError");
    }
  } catch (error) {
    console.error("Error fetching PDF:", error);
    isLoading.value = false;
    router.push("/TechnicalError");
  }
};

//************************************************--Function to update Marketing Consent Info--******************************************************

const updateMarketingConsent = async () => {
  const token = sessionStorage.getItem("authToken");
  isLoading.value = true;

  if (!refNumber.value && !token) {
    console.log("User not Authorized");
  } else {
    try {
      const response = await axios.post(
        "/updateMarketing",
        {
          REFNUMBER: refNumber.value,
          EMAILCAMPAIGNS: radioEmailCampaigns.value,
          // _PERSONALINFO: this.radioPersonalInfor,
          SMSCAMPAIGNS: radioSMSCampaigns.value,
          OTHEROFFERS: radioOtherOffers.value,
          // INAPPMSGS: radioInAppMsgs.value,
          MARKCOMMS: radioMarketingComms.value,
          MARKRESEARCH: radioMarketingResearch.value,
          NOTIFYME: radioNotifyMe.value,
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );

      if (response.status !== 200) {
        isLoading.value = false;
        router.push("/TechnicalError");
      } else {
        if (
          response.data.data.RESPONSE === "UPDATED" ||
          response.data.data.RESPONSE === "ADDED"
        ) {
          GetUserForReferenceNumber();
          if (sessionStorage.getItem("IDType") === "Passport") {
            updateLoyaltyDetails();
          } else {
            generateCustomerPDF();
            updateLoyaltyDetails();
          }
          // step.value = 5;
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
};

//************************************************--Function to update Loyalty Programme Info--******************************************************

const updateLoyaltyDetails = async () => {
  const token = sessionStorage.getItem("authToken");

  if (!refNumber.value && !token) {
    console.log("User not Authorized");
    isLoading.value = false;
    router.push("/TechnicalError");
    return;
  } else {
    try {
      const response = await axios.post(
        "/updateLoyaltyDetails",
        {
          _REFNUMBER: refNumber.value,
          _LOYALTY: radioloyaltyprogramme.value,
          _MARITALSTATUS: dropdownmaritalstatus.value,
          _SPOUSECONSENT: check_spousalconsent.value,
          _ETHNICGROUP: dropdownethnicgroup.value,
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );

      if (response.status !== 200) {
        isLoading.value = false;
        router.push("/TechnicalError");
      } else {
        // isLoading.value = false;

        if (
          response.data.data._RESPONSE === "UPDATED" ||
          response.data.data._RESPONSE === "ADDED"
        ) {
          console.log("Loyalty details successfully updated.");

          if (sessionStorage.getItem("IDType") === "Passport") {
            isLoading.value = false;
            step.value = 5;
          }
        }
      }
    } catch (error) {
      console.error(error);
      isLoading.value = false;
      router.push("/TechnicalError");
    }
  }
};

// Method to handle ID file submission
const submitIDFile = async (DocTypeID) => {
  if (!IdFileUpload.value?.files[0]) {
    idmessage.value = "Please select a file.";
    return;
  }

  const formData = new FormData();
  const idfile = IdFileUpload.value.files[0];

  formData.append("IdFileUpload", idfile);
  formData.append("DocumentType", DocTypeID);

  try {
    const authToken = sessionStorage.getItem("authToken");
    const response = await axios.post("/IDfileupload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: authToken,
      },
    });

    console.log("Respose:", response);

    if (response.data.data === "Success") {
      idmessage.value = "";
      idbutton.value = "UPLOADED";
    } else if (response.data.data === "Invalid File Format") {
      fileerrormessage.value = response.data.data;
      idmessage.value = "Please upload a PDF file format.";
    }
  } catch (error) {
    console.error("File upload failed", error);
  }
};

// Method to handle ID file upload
const handleIDFileUpload = () => {
  const idfile = IdFileUpload.value?.files[0];

  if (!idfile) {
    fileerrormessage.value = "Please select a file.";
    return;
  }

  if (idfile.type !== "application/pdf") {
    fileerrormessage.value = "Invalid File Format. Please upload a PDF.";
  } else {
    fileerrormessage.value = "";
    // Proceed with file upload (call submitIDFile or another upload function)
  }
};

// Method to handle POR file submission
const submitPORFile = async (DocTypePOR) => {
  if (!PORFileUpload.value?.files[0]) {
    idmessage.value = "Please select a file.";
    return;
  }

  const formData = new FormData();
  const porfile = PORFileUpload.value.files[0];

  formData.append("PORFileUpload", porfile);
  formData.append("DocumentType", DocTypePOR);

  try {
    const authToken = sessionStorage.getItem("authToken");
    const response = await axios.post("/PoRfileupload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: authToken,
      },
    });

    if (response.data.data === "Success") {
      idmessage.value = "";
      resbutton.value = "UPLOADED";
    } else if (response.data.data === "Invalid File Format") {
      fileerrormessage.value = response.data.data;
      idmessage.value = "Please upload a PDF file format.";
    }
  } catch (error) {
    console.error("File upload failed", error);
  }
};

// Method to handle POR file upload
const handlePORFileUpload = () => {
  const porfile = PORFileUpload.value?.files[0];

  if (!porfile) {
    fileerrormessage.value = "Please select a file.";
    return;
  }

  if (porfile.type !== "application/pdf") {
    fileerrormessage.value = "Invalid File Format. Please upload a PDF.";
  } else {
    fileerrormessage.value = "";
    // Proceed with file upload (call submitIDFile or another upload function)
  }
};

// Method to handle BankState file submission
const submitBankFile = async (DocTypeBank) => {
  if (!BankStateFileUpload.value?.files[0]) {
    idmessage.value = "Please select a file.";
    return;
  }

  const formData = new FormData();
  const bankfile = BankStateFileUpload.value.files[0];

  formData.append("BankStateFileUpload", bankfile);
  formData.append("DocumentType", DocTypeBank);

  try {
    const authToken = sessionStorage.getItem("authToken");
    const response = await axios.post("/BankStatefileupload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: authToken,
      },
    });

    if (response.data.data === "Success") {
      idmessage.value = "";
      bankbutton.value = "UPLOADED";
    } else if (response.data.data === "Invalid File Format") {
      fileerrormessage.value = response.data.data;
      idmessage.value = "Please upload a PDF file format.";
    }
  } catch (error) {
    console.error("File upload failed", error);
  }
};

// Method to handle POR file upload
const handleBankFileUpload = () => {
  const bankfile = BankStateFileUpload.value?.files[0];

  if (!bankfile) {
    fileerrormessage.value = "Please select a file.";
    return;
  }

  if (bankfile.type !== "application/pdf") {
    fileerrormessage.value = "Invalid File Format. Please upload a PDF.";
  } else {
    fileerrormessage.value = "";
    // Proceed with file upload (call submitIDFile or another upload function)
  }
};

// Method to handle PaySlip file submission
const submitPaySlipFile = async (DocTypePay) => {
  if (!PaySlipFileUpload.value?.files[0]) {
    idmessage.value = "Please select a file.";
    return;
  }

  const formData = new FormData();
  const payfile = PaySlipFileUpload.value.files[0];

  formData.append("PaySlipFileUpload", payfile);
  formData.append("DocumentType", DocTypePay);

  try {
    const authToken = sessionStorage.getItem("authToken");
    const response = await axios.post("/PaySlipfileupload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: authToken,
      },
    });

    if (response.data.data === "Success") {
      idmessage.value = "";
      payslipbutton.value = "UPLOADED";
    } else if (response.data.data === "Invalid File Format") {
      fileerrormessage.value = response.data.data;
      idmessage.value = "Please upload a PDF file format.";
    }
  } catch (error) {
    console.error("File upload failed", error);
  }
};

// Method to handle PaySlip file upload
const handlePaySlipFileUpload = () => {
  const payfile = PaySlipFileUpload.value?.files[0];

  if (!payfile) {
    fileerrormessage.value = "Please select a file.";
    return;
  }

  if (payfile.type !== "application/pdf") {
    fileerrormessage.value = "Invalid File Format. Please upload a PDF.";
  } else {
    fileerrormessage.value = "";
    // Proceed with file upload (call submitIDFile or another upload function)
  }
};

// Method to handle PaySlip file submission
const submitITA34File = async (DocTypeTax) => {
  if (!ITA34TaxFileUpload.value?.files[0]) {
    idmessage.value = "Please select a file.";
    return;
  }

  const formData = new FormData();
  const taxfile = ITA34TaxFileUpload.value.files[0];

  formData.append("ITA34TaxFileUpload", taxfile);
  formData.append("DocumentType", DocTypeTax);

  try {
    const authToken = sessionStorage.getItem("authToken");
    const response = await axios.post("/ITA34Taxfileupload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: authToken,
      },
    });

    if (response.data.data === "Success") {
      idmessage.value = "";
      itabutton.value = "UPLOADED";
    } else if (response.data.data === "Invalid File Format") {
      fileerrormessage.value = response.data.data;
      idmessage.value = "Please upload a PDF file format.";
    }
  } catch (error) {
    console.error("File upload failed", error);
  }
};

// Method to handle PaySlip file upload
const handleITA34FileUpload = () => {
  const taxfile = ITA34TaxFileUpload.value?.files[0];

  if (!taxfile) {
    fileerrormessage.value = "Please select a file.";
    return;
  }

  if (taxfile.type !== "application/pdf") {
    fileerrormessage.value = "Invalid File Format. Please upload a PDF.";
  } else {
    fileerrormessage.value = "";
    // Proceed with file upload (call submitIDFile or another upload function)
  }
};

// Methods
const checkidtype = () => {
  if (sessionStorage.getItem("IDType") === "Passport") {
    (appStatus.value = "Referred"),
      sessionStorage.setItem("AppStatus", "Referred");
    updateAppStatus();
    router.push("/CompletedApp");
  } else {
    getAppstatus();
    step.value = 6;
  }
};
// Previous button logic
const goToPrevious = () => {
  step.value = 4;
};

//************************************************--Function to update Application Status--******************************************************
const updateAppStatus = async () => {
  const token = sessionStorage.getItem("authToken");
  const userId = sessionStorage.getItem("userid"); // Set it in order to use it!!!!.

  if (!refNumber.value && !userId) {
    console.log("User not Authorized");
    isLoading.value = false;
    return;
  } else {
    try {
      const response = await axios.post(
        "/updateAppStatus",
        {
          _REFNUMBER: refNumber.value,
          _USER_ID: userId,
          _STATUS: appStatus.value,
          _STATUSDATE: formatDateYYYYMMDD(today),
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );

      if (
        response.data.data._RESPONSE === "UPDATED" ||
        response.data.data._RESPONSE === "ADDED"
      ) {
        sessionStorage.setItem("appstatus", appStatus);
        console.log("Application status successfully updated.");
        // Uncomment and modify this line if navigation is needed
        // router.push('/CompletedApp');
      }
    } catch (error) {
      console.error(error);
      isLoading.value = false;
      router.push("/TechnicalError");
    }
  }
};

const getAppstatus = async () => {
  try {
    const token = sessionStorage.getItem("authToken");
    const userId = sessionStorage.getItem("userid");
    const custRefNumbers = ref([]);

    if (!refNumber.value && !token && !userId) {
      console.log("User ID not found in session");
      isLoading.value = false;
      return;
    }

    const response = await axios.post(
      "/getAppstatus",
      {
        _USER_ID: userId,
      },
      {
        headers: {
          Authorization: token, // Passing auth token in headers
        },
      }
    );

    if (response.data.data._RESPONSE === "RecordsFnd") {
      custRefNumbers.value = response.data.data._APP_DATA;
      sessionStorage.setItem(
        "appstatus",
        response.data.data._APP_DATA[0]["_STATUS"]
      );

      // Remove empty _REFNUMBER entries
      custRefNumbers.value = custRefNumbers.value.filter(
        (item) => item._REFNUMBER !== ""
      );
    }
  } catch (error) {
    console.error(error);
    isLoading.value = false;
    router.push("/TechnicalError");
  }
};

//************************************************--Function to update PAQ (Pre-Agreement Quote) Status--******************************************************

const otpTime = ref("3:00"); // Initial value, 3 minutes
const timerRunning = ref(false);
const timerRef = ref(null);
let intervalId = null; // Store the interval ID

const timecreated = async () => {
  console.log("Starting OTP Timer...");
  await nextTick(); // Ensure DOM updates
  // if (timerRef.value) {
  startTimer(180); // 3 minutes
  // } else {
  //   console.warn("Timer element not found");
  // }
};

const startTimer = (duration) => {
  if (intervalId) clearInterval(intervalId); // Stop the previous timer
  let timer = duration;
  timerRunning.value = true;

  // otpTime.value = 180; // Reset time to 3 minutes
  expired.value = false; // Reset expired status

  intervalId = setInterval(() => {
    if (!timerRunning.value) {
      clearInterval(intervalId);
      return;
    }

    let minutes = Math.floor(timer / 60);
    let seconds = timer % 60;
    otpTime.value = `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;

    if (--timer < 0) {
      expired.value = true; // Show expiration message
      // otpTime = "Expired";
      clearInterval(intervalId);
    }
  }, 1000);
};

const resendPAQOTP = async () => {
  const userId = sessionStorage.getItem("userid");

  const token = sessionStorage.getItem("authToken");
  const maskedCell = sessionStorage.getItem("maskedCell");

  isLoading.value = true;

  if (!userId && !refNumber.value && !token) {
    console.log("User not authorized");
    isLoading.value = false;
    return;
  }

  try {
    console.log("Resend OTP triggered, expired:", expired.value);

    const response = await axios.post(
      "/resendPAQOTP",
      {
        _COMM_TYPE: sessionStorage.getItem("comtype"),
        _EMAIL: userId,
        _MASKEDCELL: maskedCell,
      },
      {
        headers: {
          Authorization: token, // Passing auth token in headers
        },
      }
    );

    console.log("Response from server:", response.data);

    isLoading.value = false;

    if (response.data.data === "NEWOTPSENT") {
      console.log(`OTP has been resent to: ${maskedCell}`);
      // Restart OTP expiration countdown
      timecreated();
      otpresent.value = true; // Show resend link
      respMessage.value = true;
      resentOTPMessage.value = `OTP has been resent to: ${maskedCell}`;
       //alert(response.data.OTP);
    } else {
      respMessageExpire.value = false;
      console.log("Failed to resend OTP");
    }
  } catch (error) {
    console.error("Error resending OTP:", error);
    isLoading.value = false;
    router.push("/TechnicalError");
  }
};

const updatePAQStatus = async () => {
  const token = sessionStorage.getItem("authToken");

  isLoading.value = true;

  if (!refNumber.value && !token) {
    console.log("User not Authorized");
    return;
  } else {
    try {
      const response = await axios.post(
        "/updatePAQStatus",
        {
          _REFNUMBER: refNumber.value,
          _CONS_PAYSLIP: check_PaylSlipandBankstate.value,
          _DCSA_TANDC: check_PAQStateandQuote.value,
          _CARD_TANDC: check_CardFeesTCs.value,
          _DECLARE_TRUE: check_TrueandCorrectInfor.value,
          _PAQ_STATUS: statusAPIvalue.value,
          _SEND_OTP: sendOPT.value,
        },

        {
          headers: {
            Authorization: token,
          },
        }
      );

      isLoading.value = false;

      if (response.status !== 200) {
        console.log("Error: Technical Issue");
        router.push("/TechnicalError");
      } else {
        if (
          response.data.data === "UPDATED" ||
          response.data._OTP_RESPONSE === "NEWOTPSENT"
        ) {
          sessionStorage.setItem("maskedCell", response.data._MASKEDCELL);
          sessionStorage.setItem("OTP", response.data.OTP);
          maskedCell.value = response.data._MASKEDCELL;
          console.log("Masked contact updated successfully.");
          //alert(response.data.OTP)
        }
      }
    } catch (error) {
      console.error(error);
      isLoading.value = false;
      router.push("/TechnicalError");
    }
  }
};

const AcceptOfferSts = () => {
  timecreated();
  maskedCell.value = sessionStorage.getItem("maskedCell");
  statusAPIvalue.value = "Accepted";
  updatePAQStatus();
};

const SignedOfferSts = () => {
  sendOPT.value = "No";
  statusAPIvalue.value = "Accepted";
  appStatus.value = "Approved";
  updateAppStatus();
};

const DeclineOfferSts = () => {
  console.log("App Declined");
  statusAPIvalue.value = "Declined";
  updatePAQStatus();
  appStatus.value = "Declined";
  updateAppStatus();
  router.push("/DeclinedOffer");
};

const PendOfferSts = () => {
  console.log("Offer Pended");
  statusAPIvalue.value = "Pending";
  updatePAQStatus();
  router.push("/DeclinedOffer");
};

//************************************************--Function to update PAQ (Pre-Agreement Quote) Status--******************************************************

const signAgreement = async () => {
  const token = sessionStorage.getItem("authToken");

  if (!refNumber.value && !token) {
    console.log("User not Authorized");
    return;
  } else {
    try {
      const response = await axios.post(
        "/signAgreement",
        {
          _REFNUMBER: refNumber.value,
          _SIGNED: signPAQ.value,
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );
      //  isLoading.value = false
      if (
        response.data.data._RESPONSE === "UPDATED" ||
        response.data.data._OTP_RESPONSE === "ADDED"
      ) {
        generateSignedCustomerPDF();
        router.push("/CardDelivery");
      }
    } catch (error) {
      console.error(error);
      isLoading.value = false;
      router.push("/TechnicalError");
    }
  }
};

//************************************************--Function to Validate OTP--******************************************************

const otpValidation = async () => {
  const userId = sessionStorage.getItem("userid");
  const token = sessionStorage.getItem("authToken");

  isLoading.value = true;

  if (!userId || !refNumber.value || !token) {
    console.log("User not authorized");
    isLoading.value = false;
    return;
  }

  const otpValue = otp.value.join(""); // Convert OTP array to string

  if (!otpValue || otpValue.length !== 6) {
    message.value = "Please enter a valid 6-digit OTP";
    return;
  }
  if (expired.value) {
    otpresent.value = false;
  } else {
    otpresent.value = true;
  }

  try {
    const response = await axios.post(
      "/paqotpValidation",
      {
        _OTP: otpValue,
        _USERID: userId,
        _REFNUMBER: refNumber.value,
      },
      {
        headers: {
          Authorization: token,
        },
      }
    );

    isLoading.value = false;

    if (!response.data.data) {
      router.push("/TechnicalError");
    } else {
      const responseData = response.data.data;

      if (responseData._RESPONSE === "OTP_match") {
        SignedOfferSts();
        signPAQ.value = "Signed";
        await signAgreement();
      } else if (responseData._ERRORMESSAGE === "TempBlocked") {
        message.value =
          "Your login details have been temporarily blocked, please try again after 15 minutes";
        respMessage.value = responseData._RESPONSE;
        router.push("/OTP_Lockedout");
      } else {
        message.value = "OTP Incorrect, Please try again";
        isLoading.value = false;
        respMessage.value = responseData._RESPONSE;
        otpresent.value = false;
      }
    }
  } catch (error) {
    console.error(error);
    isLoading.value = false;
    error.value = true;
    message.value = error.message;
    router.push("/TechnicalError");
  }
};
</script>

<style scoped>
.my-4 {
  margin: 1rem 0;
}

@font-face {
  font-family: "GathamBookNewAppTab";
  src: url("@/assets/fonts/Gotham-Book.woff2") format("woff2"),
    url("@/assets/fonts/Gotham-Book.otf") format("opentype");
  font-display: swap;
}
.NewApp-Toolbar {
  font-family: "GathamBookNewAppTab";
  /* font-size: 30px; */
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #fff;
  padding: 16px;
}

@font-face {
  font-family: "GathamLightBank";
  src: url("@/assets/fonts/Gotham-Light.woff2") format("woff2"),
    url("@/assets/fonts/Gotham-Light.otf") format("opentype");
  font-display: swap;
}
.Main-Header {
  font-family: "GathamLightBank";
  font-size: 28px;
  font-weight: 100;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #041e42;
}

@font-face {
  font-family: "GathamMediumBankDetails";
  src: url("@/assets/fonts/Gotham-Medium.woff2") format("woff2"),
    url("@/assets/fonts/Gotham-Medium.otf") format("opentype");
  font-display: swap;
}
.Your-BankingDetails {
  font-family: "GathamMediumBankDetails";
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #041e42;
}

@font-face {
  font-family: "GathamMediumLoyaltyDetails";
  src: url("@/assets/fonts/Gotham-Medium.woff2") format("woff2"),
    url("@/assets/fonts/Gotham-Medium.otf") format("opentype");
  font-display: swap;
}
.Loyalty-Details {
  font-family: "GathamMediumLoyaltyDetails";
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #041e42;
}
@font-face {
  font-family: "GathamMediumMaritalStatus";
  src: url("@/assets/fonts/Gotham-Medium.woff2") format("woff2"),
    url("@/assets/fonts/Gotham-Medium.otf") format("opentype");
  font-display: swap;
}
.Marital-Status {
  font-family: "GathamMediumMaritalStatus";
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #041e42;
}
@font-face {
  font-family: "GathamLight";
  src: url("@/assets/fonts/Gotham-Light.woff2") format("woff2"),
    url("@/assets/fonts/Gotham-Light.otf") format("opentype");
  font-display: swap;
}
.paragraph-wordings {
  font-family: "GathamLight";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #041e42;
}
.Dialog-Wording {
  font-family: "GathamBookagree";
  font-size: 15px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #fff;
}
#checkboxLabel {
  font-family: "GathamLight";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #041e42;
}
.button {
  background-color: white;
  color: #005f95;
  border: 2px solid #005f95; /* Green */
}
@font-face {
  font-family: "GathamBookagree";
  src: url("@/assets/fonts/Gotham-Book.woff2") format("woff2"),
    url("@/assets/fonts/Gotham-Book.otf") format("opentype");
  font-display: swap;
}
.Sign-Agreement {
  font-family: "GathamBookagree";
  font-size: 15px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #fff;
}
@font-face {
  font-family: "GathamMedium";
  src: url("@/assets/fonts/Gotham-Medium.woff2") format("woff2"),
    url("@/assets/fonts/Gotham-Medium.otf") format("opentype");
  font-display: swap;
}
.Sign-OTP {
  font-family: "GathamMedium";
  font-size: 10px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #041e42;
}

.section-title {
  margin-bottom: 12px; /* Adjust as needed */
  text-align: left;
}

.section-description {
  margin-bottom: -20px; /* Reduce space between text and radio group */
  text-align: left;
}

.radio-group-row {
  margin-bottom: -40px; /* Adjust for your desired spacing */
  /* margin-top:0; */
}

/* Override Vuetify styles for the active stepper item */
.active-step {
  color: #005f95;
  opacity: 1 !important; /* Ensure the active step is fully visible */
}

/* Keep completed steps fully visible (ensure no gray-out for completed steps) */
.v-stepper-item[aria-selected="true"] {
  opacity: 1 !important; /* Ensure active and completed steps are fully visible */
}

/* Dim only the inactive steps (steps that the user has not reached) */
.v-stepper-item {
  color: #2c3235; /* Dark grey text */
  transition: background-color 0.3s ease, color 0.3s ease;
  opacity: 0.3; /* Dim only inactive steps */
}

/* Ensure that completed steps are not dimmed */
.v-stepper-item[aria-selected="false"]:not(.active-step) {
  opacity: 0.3; /* Only apply opacity dimming to inactive steps */
}

/* Default stepper item circle color */
.v-stepper-item__step {
  background-color: #005f95 !important; /* Blue for all steps */
  color: white !important; /* White text inside the circle */
  border-color: #005f95 !important; /* Border color matches the circle */
}

.custom-divider {
  margin: 5px 0; /* Adjust the vertical margin to control the distance */
  height: 0px; /* Adjust the height of the divider line */
  width: 50px;
}
#warning {
  color: #9f6000;
}

#message {
  /* align-content: center;
        text-align: center; */
  color: #d8000c;
}
</style>
